// ─── Leads.js ──────────────────────────────────────────────────────────────
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useAuth } from "../context/AuthContext";
import {
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { FiSearch, FiFilter } from "react-icons/fi";
import {
  getLeads,
  getLeadStages,
  getPipelineStages,
  getSources,
  getUsers as getUsersApi,
  bulkUpdateLeadStage,
  bulkUpdateLeadSource,
  bulkAssignLeads,
  bulkDeleteLeads,
  globalSearch
} from "../api";

import LeadTable from "../components/LeadTable";
import LeadAging from "../components/LeadAging";
import FollowUpGap from "../components/followUpGap";
import TaskReminders from "../components/TaskReminders";


const SCOL = {'New Lead':'#888780','Contacted':'#378ADD','Qualified':'#BA7517','Site Visit Scheduled':'#9FE1CB','Site Visit Done':'#1D9E75','Negotiation':'#D4537E','Closed Won':'#639922','Closed Lost':'#E24B4A'};


const LEADS_SCROLL_KEY = "aranyaka_leads_scroll";
const LEADS_FILTERS_KEY = "aranyaka_leads_filters";

const loadSavedFilters = () => {
  try {
    return JSON.parse(
      sessionStorage.getItem(LEADS_FILTERS_KEY) || "{}"
    );
  } catch (err) {
    return {};
  }
};


export function Leads() {
  const { user } = useAuth();

  const [searchParams, setSearchParams] = useSearchParams();
  const savedFilters = loadSavedFilters();

  const initialPage = Math.max(
    Number(searchParams.get("page")) || 1,
    1
  );

  const initialLimit = Math.max(
    Number(searchParams.get("limit")) || 100,
    1
  );

  const initialFilter =
    searchParams.get("stage") || "all";

  const [leads, setLeads] = useState([]);
  const [limit, setLimit] = useState(initialLimit);
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
const [totalLeads, setTotalLeads] = useState(0);

const [leadCounts, setLeadCounts] = useState({
  all: 0,
  new: 0,
  inbound: 0,
  prospect: 0,
});
  const [filter, setFilter] = useState(savedFilters.filter || initialFilter);
  const [search, setSearch] = useState('');
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [showBulkMenu, setShowBulkMenu] = useState(false);
  const [leadStages, setLeadStages] = useState([]);
  const [showStageModal, setShowStageModal] = useState(false);
  const [selectedStage, setSelectedStage] = useState("");
  const [sources, setSources] = useState([]);
  const [showSourceModal, setShowSourceModal] = useState(false);
  const [selectedSource, setSelectedSource] = useState("");
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignUsers, setAssignUsers] = useState([]);
  const loadUsers = async () => {
  try {
    const res = await getUsersApi();

    // All users show honge:
    // Active + Inactive
    // Head + Sales Head + Team Lead + Sales Manager
    const users = Array.isArray(res.data)
      ? res.data
      : [];

    setAssignUsers(users);
  } catch (err) {
    console.error("Could not fetch users:", err);
    setAssignUsers([]);
  }
};
  const [selectedAssignUser, setSelectedAssignUser] = useState("");
  const [assigning, setAssigning] = useState(false);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [filterName, setFilterName] = useState(savedFilters.filterName || "");
  const [filterContact, setFilterContact] = useState(savedFilters.filterContact || "");
const [filterEmail, setFilterEmail] = useState(savedFilters.filterEmail || "");
const [filterStage, setFilterStage] = useState(savedFilters.filterStage || "");
const [filterPriority, setFilterPriority] = useState(savedFilters.filterPriority || "");
const [filterSource, setFilterSource] = useState(savedFilters.filterSource || "");
const [filterAssignTo, setFilterAssignTo] = useState(savedFilters.filterAssignTo || "");
const [filterCreatedBy, setFilterCreatedBy] = useState(savedFilters.filterCreatedBy || "");
const [creationFrom, setCreationFrom] = useState(savedFilters.creationFrom || "");
const [creationTo, setCreationTo] = useState(savedFilters.creationTo || "");
const [quickFilter, setQuickFilter] = useState(savedFilters.quickFilter || "");
  const [showQuickFilter, setShowQuickFilter] = useState(false);
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const scrollRestoredRef = useRef(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};

if (filter !== "all") params.stage = filter;
if (search) params.search = search;

if (filterName) params.name = filterName;

if (filterContact) params.contact = filterContact;

if (filterEmail) params.email = filterEmail;

if (filterStage) params.stage = filterStage;

if (filterPriority) params.priority = filterPriority;

if (filterSource) params.source = filterSource;

if (filterAssignTo) params.assigned_to = filterAssignTo;

if (filterCreatedBy) params.created_by = filterCreatedBy;

if (creationFrom) params.creation_from = creationFrom;

if (creationTo) params.creation_to = creationTo;
if (quickFilter === "assigned_today") {
  params.assigned_today = "true";
}

if (quickFilter === "duplicate") {
  params.duplicate = "true";
}

if (quickFilter === "non_duplicate") {
  params.duplicate = "false";
}
console.log("FILTER PARAMS =>", params);
      const res = await getLeads(page, limit, params);
      console.log("FILTER PARAMS =", params);
console.log("API RESPONSE =", res.data);
console.log("LEADS =", res.data.data);

      console.log("API Response =", res.data);
      console.log("Data =", res.data.data);
      console.log("Is Array =", Array.isArray(res.data.data));

setLeads(Array.isArray(res.data.data) ? res.data.data : []);
setTotalPages(res.data.totalPages || 1);
setTotalLeads(res.data.total || 0);

setLeadCounts({
  all: Number(res.data.counts?.all || res.data.total || 0),
  new: Number(res.data.counts?.new || 0),
  inbound: Number(res.data.counts?.inbound || 0),
  prospect: Number(res.data.counts?.prospect || 0),
});
      
    } finally { setLoading(false); }
  }, [
  filter,
  search,
  page,
  limit,
  filterName,
  filterContact,
  filterEmail,
  filterStage,
  filterPriority,
  filterSource,
  filterAssignTo,
filterCreatedBy,
creationFrom,
creationTo,
quickFilter,
]);
useEffect(() => {
  sessionStorage.setItem(
    LEADS_FILTERS_KEY,
    JSON.stringify({
      filter,
      filterName,
      filterContact,
      filterEmail,
      filterStage,
      filterPriority,
      filterSource,
      filterAssignTo,
      filterCreatedBy,
      creationFrom,
      creationTo,
      quickFilter,
    })
  );
}, [
  filter,
  filterName,
  filterContact,
  filterEmail,
  filterStage,
  filterPriority,
  filterSource,
  filterAssignTo,
  filterCreatedBy,
  creationFrom,
  creationTo,
  quickFilter,
]);
useEffect(() => {
  load();
}, [load]);

useEffect(() => {
  loadLeadStages();
  loadSources();
  loadUsers();
}, []);
useEffect(() => {
  setSearchParams((current) => {
    const params = new URLSearchParams(current);

    params.set("page", page);
    params.set("limit", limit);

    if (filter !== "all") {
      params.set("stage", filter);
    } else {
      params.delete("stage");
    }

    return params;
  }, {
    replace: true,
  });
}, [page, limit, filter, setSearchParams]);
useEffect(() => {
  if (loading || scrollRestoredRef.current) {
    return;
  }

  const savedScrollTop =
    Number(sessionStorage.getItem(LEADS_SCROLL_KEY)) || 0;

  const timer = window.setTimeout(() => {
    if (tableRef.current) {
      tableRef.current.scrollTop = savedScrollTop;
    }

    scrollRestoredRef.current = true;
  }, 50);

  return () => window.clearTimeout(timer);
}, [loading]);
const toggleLead = (id) => {
  setSelectedLeads((prev) =>
    prev.includes(id)
      ? prev.filter((x) => x !== id)
      : [...prev, id]
  );
};

const filteredLeads = leads;

const handleSelectAll = () => {
  if (selectedLeads.length === filteredLeads.length) {
    setSelectedLeads([]);
  } else {
    setSelectedLeads(filteredLeads.map((lead) => lead.id));
  }
};
async function loadLeadStages() {
  try {
    const res = await getLeadStages();
    setLeadStages(res.data);
  } catch (err) {
    console.log(err);
  }
}

async function loadSources() {
  try {
    const res = await getSources();
    setSources(res.data);
  } catch (err) {
    console.log(err);
  }
}

const handleApplyFilters = () => {
  setPage(1);
  load();
  setShowFilterPanel(false);
};

const handleBulkStageUpdate = async () => {
  if (!selectedStage) {
    alert("Please select a stage");
    return;
  }

  if (selectedLeads.length === 0) {
    alert("Please select at least one lead");
    return;
  }

await bulkUpdateLeadStage(
  selectedLeads,
  selectedStage
);

await load();

// Close popup
setShowStageModal(false);

// Clear dropdown
setSelectedStage("");

// Clear selected checkboxes
setSelectedLeads([]);

//alert("Stage updated successfully");
};

const handleBulkSourceUpdate = async () => {
  if (!selectedSource) {
    alert("Please select a source");
    return;
  }

  if (selectedLeads.length === 0) {
    alert("Please select at least one lead");
    return;
  }

  try {
    await bulkUpdateLeadSource(
      selectedLeads,
      selectedSource
    );

    await load();

    setShowSourceModal(false);
    setSelectedSource("");
    setSelectedLeads([]);
  } catch (err) {
    console.log("FULL ERROR =", err);
    console.log("RESPONSE =", err.response);
    console.log("DATA =", err.response?.data);

    alert(
      err.response?.data?.error ||
      err.response?.data?.message ||
      err.message
    );
}
};

const openAssignModal = async () => {
  if (selectedLeads.length === 0) {
    alert("Please select at least one lead");
    return;
  }

  try {
    const response = await getUsersApi();

    const users = Array.isArray(response.data)
  ? response.data
  : [];

const filteredUsers =
  user?.role === "team_lead"
    ? users.filter(
        (u) =>
          u.is_active &&
          u.role === "sales_manager" &&
          String(u.team_lead_id) === String(user.id)
      )
    : users.filter(
        (u) =>
          u.is_active &&
          (
            u.role === "sales_manager" ||
            u.role === "team_lead" ||
            u.role === "sales_head"        
          )
      );

setAssignUsers(filteredUsers);
    setSelectedAssignUser("");
    setShowBulkMenu(false);
    setShowAssignModal(true);
  } catch (err) {
    console.error("GET USERS ERROR:", err);

    alert(
      err.response?.data?.error ||
      "Could not fetch Sales Managers"
    );
  }
};

const handleAssignLeads = async () => {
  if (!selectedAssignUser) {
    alert("Please select a User");
    return;
  }

  if (selectedLeads.length === 0) {
    alert("Please select at least one lead");
    return;
  }

  try {
    setAssigning(true);

    const response = await bulkAssignLeads(
      selectedLeads,
      selectedAssignUser
    );

    alert(
      response.data?.message ||
      "Leads assigned successfully"
    );

    setShowAssignModal(false);
    setSelectedAssignUser("");
    setSelectedLeads([]);

    await load();
  } catch (err) {
    console.error("ASSIGN LEADS ERROR:", err);

    alert(
      err.response?.data?.error ||
      "Could not assign leads"
    );
  } finally {
    setAssigning(false);
  }
};


const handleDeleteSelected = async () => {

  if (selectedLeads.length === 0) {
    alert("Please select at least one lead");
    return;
  }

  const confirmDelete = window.confirm(
    `Delete ${selectedLeads.length} selected lead(s)?`
  );

  if (!confirmDelete) return;

  try {

    await bulkDeleteLeads(selectedLeads);

    alert("Selected leads deleted successfully");

    setSelectedLeads([]);
    setShowBulkMenu(false);

    await load();

  } catch (err) {

    console.error(err);

    alert(
      err.response?.data?.error ||
      "Could not delete selected leads"
    );

  }

};

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      <div className="page-header">
        <div>
          <div className="page-title">All Leads</div>
          <div className="page-subtitle">{totalLeads} leads</div>
        </div>
        <div
  style={{
    display: "flex",
    gap: "8px",
    alignItems: "center",
  }}
>
  <input
    className="form-input"
    style={{ width: "220px" }}
    placeholder="Search name, phone, email..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    onKeyDown={async (e) => {
      if (e.key !== "Enter") return;

      const text = searchText.trim();

      if (!text) return;

      navigate(`/search?q=${encodeURIComponent(text)}`);
    }}
  />

  <div style={{ position: "relative" }}>
    <button
      type="button"
      onClick={() => setShowQuickFilter((prev) => !prev)}
      title="Quick Filters"
      style={{
        width: 38,
        height: 38,
        border: quickFilter
          ? "1px solid #1D9E75"
          : "1px solid #D9D9D9",
        borderRadius: 10,
        background: quickFilter ? "#ECFDF5" : "#fff",
        color: quickFilter ? "#1D9E75" : "#555",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FiFilter size={18} />
    </button>

    {showQuickFilter && (
      <div
        style={{
          position: "absolute",
          top: "calc(100% + 8px)",
          right: 0,
          width: 190,
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 8,
          boxShadow: "0 8px 24px rgba(0,0,0,.14)",
          zIndex: 9999,
          overflow: "hidden",
        }}
      >
        {[
          { value: "assigned_today", label: "Assigned Today" },
          { value: "duplicate", label: "Duplicate" },
          { value: "non_duplicate", label: "Non Duplicate" },
        ].map((item) => (
          <div
            key={item.value}
            onClick={() => {
              setQuickFilter(item.value);
              setPage(1);
              setShowQuickFilter(false);
            }}
            style={{
              padding: "11px 14px",
              cursor: "pointer",
              fontSize: 13,
              background:
                quickFilter === item.value
                  ? "#ECFDF5"
                  : "#fff",
              color:
                quickFilter === item.value
                  ? "#1D9E75"
                  : "#222",
              fontWeight:
                quickFilter === item.value
                  ? 600
                  : 400,
              borderBottom: "1px solid #F3F4F6",
            }}
          >
            {item.label}
          </div>
        ))}

        <div
          onClick={() => {
            setQuickFilter("");
            setPage(1);
            setShowQuickFilter(false);
          }}
          style={{
            padding: "11px 14px",
            cursor: "pointer",
            fontSize: 13,
            color: "#DC2626",
          }}
        >
          Clear Filter
        </div>
      </div>
    )}
  </div>
</div>
      </div>
      <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    background: "#fff",
    borderBottom: "0.5px solid rgba(0,0,0,0.08)",
    flexShrink: 0,
  }}
>
  {[
  {
    stage_name: "all",
    display_name: "All",
    filter_value: "all",
  },
  {
    stage_name: "new",
    display_name: "New",
    filter_value: "New",
  },
  {
    stage_name: "inbound",
    display_name: "Inbound",
    filter_value: "Inbound",
  },
  {
    stage_name: "prospect",
    display_name: "Prospect",
    filter_value: "Prospect",
  },
].map((stage) => (
  <button
    key={stage.stage_name}
    onClick={() => {
      sessionStorage.setItem(LEADS_SCROLL_KEY, "0");

      if (tableRef.current) {
        tableRef.current.scrollTop = 0;
      }

      // Stage filter clear karo
      setFilterStage("");

      // Selected tab
      setFilter(stage.filter_value);

      // First page
      setPage(1);
    }}
    style={{
      padding: "4px 12px",
      borderRadius: "20px",
      border: "0.5px solid",
      fontSize: "12px",
      cursor: "pointer",
      whiteSpace: "nowrap",

      background:
        filter === stage.filter_value
          ? "#1D9E75"
          : "transparent",

      borderColor:
        filter === stage.filter_value
          ? "#1D9E75"
          : "rgba(0,0,0,0.15)",

      color:
        filter === stage.filter_value
          ? "#fff"
          : "#666",
    }}
  >
    {stage.display_name}{" "}

    {stage.filter_value === "all" &&
      `(${leadCounts.all.toLocaleString()})`}

    {stage.filter_value === "New" &&
      `(${leadCounts.new.toLocaleString()})`}

    {stage.filter_value === "Inbound" &&
      `(${leadCounts.inbound.toLocaleString()})`}

    {stage.filter_value === "Prospect" &&
      `(${leadCounts.prospect.toLocaleString()})`}
  </button>
))}

  <div
    onClick={() => {
      setShowFilterPanel(true);
    }}
    style={{
      width: 38,
      height: 29,
      borderRadius: "50%",
      border: "1px solid #D9D9D9",
      background: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      flexShrink: 0,
    }}
  >
    <FiSearch size={18} color="#666" />
  </div>
        
      </div>
      <div
  ref={tableRef}
  onScroll={(event) => {
  sessionStorage.setItem(
    LEADS_SCROLL_KEY,
    String(event.currentTarget.scrollTop)
  );
}}
  style={{
    flex: 1,
    overflow: "auto",
    padding: "0 20px",
  }}
>
        <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 0",
    background: "#fff",
    borderBottom: "1px solid #eee",
    marginBottom: "8px",
    position: "sticky",
    top: 0,
    zIndex: 20,
  }}
>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 8,
      fontSize: 13,
    }}
  >
    <label htmlFor="lead-page-limit">Show:</label>

    <select
      id="lead-page-limit"
      value={limit}
      onChange={(e) => {
  sessionStorage.setItem(LEADS_SCROLL_KEY, "0");

  if (tableRef.current) {
    tableRef.current.scrollTop = 0;
  }

  setLimit(Number(e.target.value));
  setPage(1);
}}
      style={{
        height: 30,
        padding: "0 8px",
        border: "1px solid #ccc",
        borderRadius: 4,
      }}
    >
      <option value={30}>30</option>
      <option value={50}>50</option>
      <option value={100}>100</option>
      <option value={200}>200</option>
      <option value={500}>500</option>
      <option value={1000}>1000</option>
    </select>
  </div>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      fontSize: 13,
    }}
  >
    <button
      type="button"
      disabled={page === 1}
      onClick={() => {
  sessionStorage.setItem(LEADS_SCROLL_KEY, "0");

  if (tableRef.current) {
    tableRef.current.scrollTop = 0;
  }

  setPage((currentPage) => currentPage - 1);
}}
      style={{
        padding: "5px 10px",
        cursor: page === 1 ? "not-allowed" : "pointer",
      }}
    >
      Previous
    </button>

    <span>
      Page {page} of {totalPages}
    </span>

    <button
      type="button"
      disabled={page === totalPages}
      onClick={() => {
  sessionStorage.setItem(LEADS_SCROLL_KEY, "0");

  if (tableRef.current) {
    tableRef.current.scrollTop = 0;
  }

  setPage((currentPage) => currentPage + 1);
}}
      style={{
        padding: "5px 10px",
        cursor: page === totalPages ? "not-allowed" : "pointer",
      }}
    >
      Next
    </button>
  </div>
</div>
        {loading ? <div className="loading-screen"><div className="spinner" /></div> : (
          <LeadTable
    leads={filteredLeads}
    page={page}
    limit={limit}
    selectedLeads={selectedLeads}
    toggleLead={toggleLead}
    handleSelectAll={handleSelectAll}

    showBulkMenu={showBulkMenu}
    setShowBulkMenu={setShowBulkMenu}

    setShowStageModal={setShowStageModal}
    setShowSourceModal={setShowSourceModal}
    openAssignModal={openAssignModal}
    handleDeleteSelected={handleDeleteSelected}
/>

        
        )}

        
      </div>


{showAssignModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.35)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        width: 420,
        background: "#fff",
        borderRadius: 10,
        padding: 25,
      }}
    >
      <h3 style={{ marginTop: 0 }}>
        Assign Leads
      </h3>

      <div
        style={{
          fontSize: 13,
          color: "#666",
          marginBottom: 14,
        }}
      >
        {selectedLeads.length} lead(s) selected
      </div>

      <select
        value={selectedAssignUser}
        onChange={(event) =>
          setSelectedAssignUser(event.target.value)
        }
        style={{
          width: "100%",
          padding: 10,
          marginBottom: 20,
          border: "1px solid #ddd",
          borderRadius: 6,
        }}
      >
        <option value="">
  Select User
</option>

{assignUsers.map((selectedUser) => (
  <option
    key={selectedUser.id}
    value={selectedUser.id}
  >
    {selectedUser.name} — {selectedUser.email}
  </option>
))}
      </select>

      {assignUsers.length === 0 && (
  <div
    style={{
      color: "#DC2626",
      fontSize: 12,
      marginBottom: 15,
    }}
  >
    No users found.
  </div>
)}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
        }}
      >
        <button
          onClick={() => {
            setShowAssignModal(false);
            setSelectedAssignUser("");
          }}
          disabled={assigning}
        >
          Cancel
        </button>

        <button
          onClick={handleAssignLeads}
          disabled={
            assigning ||
            !selectedAssignUser ||
            assignUsers.length === 0
          }
          style={{
            background: "#16a34a",
            color: "#fff",
            border: "none",
            padding: "10px 18px",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          {assigning ? "Assigning..." : "Assign Leads"}
        </button>
      </div>
    </div>
  </div>
)}



        {showStageModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              width: 420,
              background: "#fff",
              borderRadius: 10,
              padding: 25,
            }}
          >
            <h3>Update Lead Stage</h3>

            <select
              value={selectedStage}
              onChange={(e) => setSelectedStage(e.target.value)}
              style={{
                width: "100%",
                padding: 10,
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              <option value="">Select Stage</option>

              {leadStages.map((stage) => (
                <option
  key={stage.id}
  value={stage.stored_value || stage.stage_name}
>
  {stage.display_name}
</option>
              ))}
            </select>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <button
                onClick={() => {
                  setShowStageModal(false);
                  setSelectedStage("");
                }}
              >
                Cancel
              </button>

              <button
                  onClick={handleBulkStageUpdate}
                  style={{
                  background: "#16a34a",
                  color: "#fff",
                  border: "none",
                  padding: "10px 18px",
                  borderRadius: 6,
                }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {showSourceModal && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.35)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    }}
  >
    <div
      style={{
        width: 420,
        background: "#fff",
        borderRadius: 10,
        padding: 25,
      }}
    >
      <h3>Update Lead Source</h3>

      <select
        value={selectedSource}
        onChange={(e) => setSelectedSource(e.target.value)}
        style={{
          width: "100%",
          padding: 10,
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        <option value="">Select Source</option>

        {sources.map((source) => (
          <option key={source.id} value={source.source_name}>
            {source.source_name}
          </option>
        ))}
      </select>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
        }}
      >
        <button
          onClick={() => {
            setShowSourceModal(false);
            setSelectedSource("");
          }}
        >
          Cancel
        </button>

        <button
          onClick={handleBulkSourceUpdate}
          style={{
            background: "#16a34a",
            color: "#fff",
            border: "none",
            padding: "10px 18px",
            borderRadius: 6,
          }}
        >
          Update
        </button>
      </div>
    </div>
  </div>
)}

<>
  <div
    onClick={() => {
  setShowFilterPanel(false);
}}
    style={{
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.25)",
  zIndex: 9998,

  opacity: showFilterPanel ? 1 : 0,
  visibility: showFilterPanel ? "visible" : "hidden",
  transition: "all .30s ease",
}}
  />

  <div
            style={{
  position: "fixed",
  top: 0,
  right: 0,

  width: 370,
  height: "100vh",

  background: "#fff",

  zIndex: 9999,

  boxShadow: "-5px 0 25px rgba(0,0,0,.15)",

  transform: showFilterPanel
    ? "translateX(0)"
    : "translateX(100%)",

  transition: "transform 350ms cubic-bezier(.22,1,.36,1)",

  willChange: "transform",

  padding: 25,

  overflowY: "auto",
}}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 25,
      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: 18,
        }}
      >
        Filter Leads
      </h3>

      <button
        onClick={() => {
  setShowFilterPanel(false);
}}
        style={{
          border: "none",
          background: "transparent",
          fontSize: 24,
          cursor: "pointer",
        }}
      >
        ×
      </button>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>

  <div>
    <label
      style={{
        display: "block",
        fontSize: 13,
        marginBottom: 6,
        color: "#444",
      }}
    >
      Creation Date From
    </label>

    <input
      type="date"
      value={creationFrom}
      onChange={(e) => setCreationFrom(e.target.value)}
      style={{
        width: "100%",
        height: 42,
        border: "1px solid #D9D9D9",
        borderRadius: 4,
        padding: "0 10px",
      }}
    />
  </div>

  <div>
    <label
      style={{
        display: "block",
        fontSize: 13,
        marginBottom: 6,
        color: "#444",
      }}
    >
      Creation Date To
    </label>

    <input
      type="date"
      value={creationTo}
      onChange={(e) => setCreationTo(e.target.value)}
      style={{
        width: "100%",
        height: 42,
        border: "1px solid #D9D9D9",
        borderRadius: 4,
        padding: "0 10px",
      }}
    />
  </div>

  <div>
    <label
      style={{
        display: "block",
        fontSize: 13,
        marginBottom: 6,
        color: "#444",
      }}
    >
      Assign To
    </label>

    <select
  value={filterAssignTo}
  onChange={(e) => setFilterAssignTo(e.target.value)}
  style={{
    width: "100%",
    height: 42,
    border: "1px solid #D9D9D9",
    borderRadius: 4,
    padding: "0 10px",
  }}
>
  <option value="">Select</option>

  {assignUsers.map((user) => (
    <option
      key={user.id}
      value={user.id}
    >
      {user.name}
    </option>
  ))}

</select>
  </div>
<div>
  <label
    style={{
      display: "block",
      fontSize: 13,
      marginBottom: 6,
      color: "#444",
    }}
  >
    Name
  </label>

  <input
    type="text"
    value={filterName}
    onChange={(e) => setFilterName(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  />
</div>



<div>
  <label
    style={{
      display: "block",
      fontSize: 13,
      marginBottom: 6,
      color: "#444",
    }}
  >
    Contact
  </label>

  <input
    type="text"
    value={filterContact}
    onChange={(e) => setFilterContact(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  />
</div>

<div>
  <label
    style={{
      display: "block",
      fontSize: 13,
      marginBottom: 6,
      color: "#444",
    }}
  >
    Email
  </label>

  <input
    type="text"
    value={filterEmail}
    onChange={(e) => setFilterEmail(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  />
</div>

<div>
  <label
    style={{
      display: "block",
      fontSize: 13,
      marginBottom: 6,
      color: "#444",
    }}
  >
    Stage
  </label>

  <select
    value={filterStage}
    onChange={(e) => setFilterStage(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  >
    <option value="">Select</option>

    {leadStages.map((stage) => (
      <option
  key={stage.id}
  value={stage.stored_value || stage.stage_name}
>
  {stage.display_name}
</option>
    ))}
  </select>
</div>

<div>
  <label
    style={{
      display: "block",
      fontSize: 13,
      marginBottom: 6,
      color: "#444",
    }}
  >
    Priority
  </label>

  <select
    value={filterPriority}
    onChange={(e) => setFilterPriority(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  >
    
    
    <option value="">Select</option>
    <option value="Hot">Hot</option>
    <option value="Warm">Warm</option>
    <option value="Cold">Cold</option>
  </select>
</div>

<div>
  <label
    style={{
      display: "block",
      fontSize: 13,
      marginBottom: 6,
      color: "#444",
    }}
  >
    Source
  </label>

  <select
    value={filterSource}
    onChange={(e) => setFilterSource(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  >
    <option value="">Select</option>

    {sources.map((source) => (
      <option
        key={source.id}
        value={source.source_name}
      >
        {source.source_name}
      </option>
    ))}
  </select>
</div>

<div>
  <label
    style={{
      display: "block",
      fontSize: 13,
      marginBottom: 6,
      color: "#444",
    }}
  >
    Created By
  </label>

  <input
    type="text"
    value={filterCreatedBy}
    onChange={(e) => setFilterCreatedBy(e.target.value)}
    style={{
      width: "100%",
      height: 42,
      border: "1px solid #D9D9D9",
      borderRadius: 4,
      padding: "0 10px",
    }}
  />
  <div
  style={{
    display: "flex",
    justifyContent: "center",
    marginTop: 20,
    marginBottom: 20,
  }}
>
  <button
    onClick={handleApplyFilters}
    style={{
      background: "#7CB518",
      color: "#fff",
      border: "none",
      borderRadius: 25,
      padding: "12px 38px",
      fontSize: 15,
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: "0 3px 10px rgba(0,0,0,.12)",
      transition: ".2s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "#6AA30F";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "#7CB518";
    }}
  >
    Apply
  </button>
</div>
</div>
</div>
  </div>
</>
<TaskReminders />

    </div>
  );
}

// ─── AddLead.js ─────────────────────────────────────────────────────────────
import { createLead } from '../api';


export function AddLead() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [form, setForm] = useState({
    name:'', phone:'', email:'', city:'',
    source:'Meta (Facebook)', campaign_name:'', source_lead_id:'',
    product_interest:'Farm Estate', budget_cr:'', priority:'warm', stage:'', notes:''
  });
  const [assignTo, setAssignTo] = useState('');
  const [salespeople, setSalespeople] = useState([]);
  const [saving, setSaving] = useState(false);
  const [leadStages, setLeadStages] = useState([]);
  const [error, setError] = useState('');

useEffect(() => {
  // Load All Leads stages + Active Deal stages
  Promise.all([
    getLeadStages(),
    getPipelineStages()
  ])
    .then(([leadRes, pipelineRes]) => {

      const leadStageList =
        Array.isArray(leadRes.data)
          ? leadRes.data
          : [];

      const pipelineStageList =
        Array.isArray(pipelineRes.data)
          ? pipelineRes.data
          : [];

      // Merge both lists
      const combinedStages = [
        ...leadStageList,
        ...pipelineStageList
      ];

      // Remove duplicate stages, e.g. Prospect
      const uniqueStages = combinedStages.filter(
  (stage, index, self) => {
    const value = String(
      stage.display_name ||
      stage.stored_value ||
      stage.stage_name ||
      ""
    )
      .trim()
      .toLowerCase();

    return (
      index ===
      self.findIndex((item) => {
        const itemValue = String(
          item.display_name ||
          item.stored_value ||
          item.stage_name ||
          ""
        )
          .trim()
          .toLowerCase();

        return itemValue === value;
      })
    );
  }
);

      setLeadStages(uniqueStages);

      // Default first stage
      if (uniqueStages.length > 0) {
        setForm((prev) => ({
          ...prev,
          stage:
            uniqueStages[0].stored_value ||
            uniqueStages[0].stage_name,
        }));
      }
    })
    .catch((err) => {
      console.error(
        "GET ADD LEAD STAGES ERROR:",
        err
      );
    });
  // Sales Manager: automatically assign lead to himself
  if (user?.role === "sales_manager") {
    setAssignTo(String(user.id));
    return;
  }

  // Admin / other allowed users: load all users
getUsersApi()
  .then((r) => {
    const users = Array.isArray(r.data)
      ? r.data
      : [];

    setSalespeople(users);

    if (users.length) {
      setAssignTo(String(users[0].id));
    }
  })
  .catch((err) => {
    console.error("GET USERS ERROR:", err);
  });
    
}, [user]);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const save = async () => {
  if (!form.name || !form.phone) {
    setError("Name and phone are required");
    return;
  }

  setSaving(true);
  setError("");

  try {

    const assignedUser =
      user.role === "sales_manager"
        ? user.id
        : assignTo;

    await createLead({
      ...form,
      assigned_to: assignedUser,
    });

    navigate("/pipeline");

  } catch (err) {

    setError(
      err.response?.data?.error ||
      "Could not save lead"
    );

  } finally {

    setSaving(false);

  }
};

  const SOURCES = ['Meta (Facebook)','Meta (Instagram)','DV360','IVR','Google Ads','Referral','Walk-in','Website','Event','Other'];
  const canAssign = user?.role !== 'sales_manager';

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      <div className="page-header">
        <div><div className="page-title">Add Lead</div></div>
        <div style={{ display:'flex', gap:'8px' }}>
          <button className="btn" onClick={() => navigate(-1)}>Cancel</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving…' : 'Save Lead'}</button>
        </div>
      </div>
      <div className="page-body">
        {error && <div style={{ background:'#FCEBEB', color:'#A32D2D', padding:'10px 14px', borderRadius:'8px', fontSize:'13px', marginBottom:'14px' }}>{error}</div>}
        <div style={{ maxWidth:'700px' }}>
          <div className="form-section">
            <div className="form-section-title">Contact</div>
            <div className="form-row">
              <div className="form-field"><label className="form-label">Full name *</label><input className="form-input" value={form.name} onChange={e=>set('name',e.target.value)} placeholder="Rajesh Kumar"/></div>
              <div className="form-field"><label className="form-label">Phone *</label><input className="form-input" value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="+91 98765 43210"/></div>
            </div>
            <div className="form-row">
              <div className="form-field"><label className="form-label">Email</label><input className="form-input" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="email@example.com"/></div>
              <div className="form-field"><label className="form-label">City</label><input className="form-input" value={form.city} onChange={e=>set('city',e.target.value)} placeholder="Delhi"/></div>
            </div>
          </div>
          <div className="form-section">
            <div className="form-section-title">Source & campaign</div>
            <div className="form-row">
              <div className="form-field"><label className="form-label">Source platform</label>
                <select className="form-input" value={form.source} onChange={e=>set('source',e.target.value)}>
                  {SOURCES.map(s=><option key={s}>{s}</option>)}
                </select></div>
              <div className="form-field"><label className="form-label">Campaign name</label><input className="form-input" value={form.campaign_name} onChange={e=>set('campaign_name',e.target.value)} placeholder="e.g. FB_FarmEstate_June26"/></div>
            </div>
            <div className="form-field"><label className="form-label">Source lead ID (from platform)</label><input className="form-input" value={form.source_lead_id} onChange={e=>set('source_lead_id',e.target.value)} placeholder="e.g. FB_98123 (optional)"/></div>
          </div>
          <div className="form-section">
            <div className="form-section-title">Lead details</div>
            <div className="form-row">
              <div className="form-field"><label className="form-label">Product interest</label>
                <select className="form-input" value={form.product_interest} onChange={e=>set('product_interest',e.target.value)}>
                  {['Farm Estate','Villa — Hill','Villa — Riverside','Plot','Other'].map(p=><option key={p}>{p}</option>)}
                </select></div>
              <div className="form-field"><label className="form-label">Budget (₹ Crore)</label><input className="form-input" type="number" step="0.1" value={form.budget_cr} onChange={e=>set('budget_cr',e.target.value)} placeholder="1.5"/></div>
            </div>
            <div className="form-row">
              <div className="form-field"><label className="form-label">Priority</label>
                <select className="form-input" value={form.priority} onChange={e=>set('priority',e.target.value)}>
                  <option value="hot">Hot</option><option value="warm">Warm</option><option value="cold">Cold</option>
                </select></div>
              <div className="form-field"><label className="form-label">Stage</label>
                <select
  className="form-input"
  value={form.stage}
  onChange={(e) => set("stage", e.target.value)}
>
  {leadStages.map((stage) => (
    <option
      key={stage.id}
      value={stage.stored_value || stage.stage_name}
    >
      {stage.display_name}
    </option>
  ))}
</select></div>
            </div>
            <div className="form-field"><label className="form-label">Notes</label><textarea className="form-input" rows={3} value={form.notes} onChange={e=>set('notes',e.target.value)} placeholder="Any initial observations about this lead…" /></div>
          </div>
          {canAssign && salespeople.length > 0 && (
            <div className="form-section">
              <div className="form-section-title">Assignment</div>
              <div className="form-field"><label className="form-label">Assign to</label>
                <select className="form-input" value={assignTo} onChange={e=>setAssignTo(e.target.value)}>
                  {salespeople.map(u=><option key={u.id} value={u.id}>{u.name}</option>)}
                </select></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Sources.js ─────────────────────────────────────────────────────────────
export function Sources() {
  const [tab, setTab] = useState('meta');
  const base = window.location.hostname === 'localhost' ? 'https://crm.aranyakaestates.com' : `https://${window.location.hostname}`;
  const token = 'YOUR_WEBHOOK_SECRET'; // shown in settings after deploy

  const tabs = [
    { id:'meta', label:'Meta (FB/IG)' },
    { id:'dv360', label:'DV360' },
    { id:'ivr', label:'IVR / Smartping' },
    { id:'api', label:'Universal API' },
  ];

  const content = {
    meta: {
      title: 'Meta Lead Ads webhook',
      instruction: 'In Meta Business Suite → Lead Ads → CRM Integration → paste this URL:',
      url: `${base}/webhooks/meta`,
      fields: ['Name','Phone','Email','City','Ad ID','Ad Set Name','Campaign Name','Form ID','Lead ID','Platform (FB/IG)'],
      extra: <div style={{ fontSize:'12px', color:'#888', marginTop:'10px' }}>Set Verify Token to: <code style={{ background:'#f0f0ee', padding:'2px 6px', borderRadius:'4px' }}>aranyaka_meta_verify</code></div>
    },
    dv360: {
      title: 'Google DV360 / Display & Video 360',
      instruction: 'Use with Google Lead Form extensions or Floodlight tags. POST to:',
      url: `${base}/webhooks/dv360?token=${token}`,
      fields: ['Name','Phone','Email','Campaign ID','Campaign Name','Line Item','Creative ID','Click ID','Timestamp']
    },
    ivr: {
      title: 'IVR Integration',
      instruction: 'Works with Smartping, Exotel, Knowlarity, MyOperator, Ozonetel. Set webhook URL to:',
      url: `${base}/webhooks/ivr?token=${token}`,
      fields: ['Caller Phone','IVR Number Dialled','Call Duration','Recording URL','Timestamp','Disposition','IVR Menu Selection'],
      extra: <div style={{ fontSize:'12px', color:'#888', marginTop:'10px' }}>For Smartping call completion, set an additional webhook to: <code style={{ background:'#f0f0ee', padding:'2px 6px', borderRadius:'4px', fontSize:'11px' }}>{base}/webhooks/smartping-call?token={token}</code></div>
    },
    api: {
      title: 'Universal Webhook API',
      instruction: 'POST leads from any platform — landing pages, Google Ads, websites:',
      url: `${base}/webhooks/universal?token=${token}`,
      fields: [],
      extra: <pre style={{ background:'#2C2C2A', color:'#9FE1CB', padding:'12px 14px', borderRadius:'8px', fontSize:'11px', lineHeight:'1.7', marginTop:'10px', overflow:'auto' }}>{`POST ${base}/webhooks/universal

{
  "name": "Rajesh Kumar",
  "phone": "+91 98765 43210",
  "email": "rajesh@email.com",
  "city": "Delhi",
  "source": "Google Ads",
  "campaign": "GA_FarmEstate_June26",
  "product": "Farm Estate",
  "token": "${token}"
}`}</pre>
    }
  };

  const c = content[tab];

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      <div className="page-header">
        <div><div className="page-title">Sources & Webhooks</div><div className="page-subtitle">Connect external platforms to auto-capture leads</div></div>
      </div>
      <div className="page-body">
        <div style={{ maxWidth:'680px' }}>
          <div style={{ display:'flex', gap:'6px', marginBottom:'16px', flexWrap:'wrap' }}>
            {tabs.map(t => (
              <button key={t.id} onClick={() => setTab(t.id)}
                style={{ padding:'6px 14px', borderRadius:'20px', border:'0.5px solid', fontSize:'13px', cursor:'pointer',
                  background: tab===t.id ? '#1D9E75' : 'transparent',
                  borderColor: tab===t.id ? '#1D9E75' : 'rgba(0,0,0,0.15)',
                  color: tab===t.id ? '#fff' : '#666' }}>
                {t.label}
              </button>
            ))}
          </div>
          <div className="card">
            <div style={{ fontSize:'14px', fontWeight:'600', marginBottom:'8px' }}>{c.title}</div>
            <div style={{ fontSize:'13px', color:'#666', marginBottom:'8px' }}>{c.instruction}</div>
            <div style={{ background:'#f5f5f3', borderRadius:'8px', padding:'10px 14px', fontFamily:'monospace', fontSize:'12px', color:'#444', wordBreak:'break-all', marginBottom:'10px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'10px' }}>
              <span>{c.url}</span>
              <button className="btn btn-sm" onClick={() => navigator.clipboard.writeText(c.url)}>Copy</button>
            </div>
            {c.fields.length > 0 && <>
              <div style={{ fontSize:'12px', fontWeight:'600', color:'#888', marginBottom:'8px' }}>Fields captured automatically:</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'6px', marginBottom:'10px' }}>
                {c.fields.map(f => <div key={f} style={{ fontSize:'12px', background:'#f5f5f3', padding:'5px 10px', borderRadius:'6px', color:'#555' }}>✓ {f}</div>)}
              </div>
            </>}
            {c.extra}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Reports.js ─────────────────────────────────────────────────────────────
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import {
  getPipelineReport,
  getForecastReport,
  getSalespersonReport,
  getSourceReport,
  getCallStatsReport,
  getDailySalesPerformance,
getDailyFollowUp,
getDailyFollowUpDetails,
getStageReport
} from '../api';

export function Reports() {
  const { user } = useAuth();

const isSalesManager =
  user?.role === "sales_manager";

const isTeamLead =
  user?.role === "team_lead";

const isSalesHead =
  user?.role === "sales_head";
  const [data, setData] = useState({ pipeline:[], forecast:{}, salespeople:[], sources:[], callStats:[] });
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(
  user?.role === "sales_manager"
    ? "daily-follow-up"
    : user?.role === "team_lead" ||
      user?.role === "sales_head"
    ? "daily"
    : "pipeline"
);
  const [dailyData, setDailyData] = useState([]);
const [dailyLoading, setDailyLoading] = useState(false);



const today = new Date().toISOString().split("T")[0];

// ========================================
// STAGE REPORT
// ========================================
const [stageReportData, setStageReportData] = useState([]);
const [stageReportLoading, setStageReportLoading] = useState(false);

const [stageReportFrom, setStageReportFrom] = useState(today);
const [stageReportTo, setStageReportTo] = useState(today);
const [stageReportAssignedTo, setStageReportAssignedTo] = useState("");

const [dailyFrom, setDailyFrom] = useState(today);
const [dailyTo, setDailyTo] = useState(today);
const [dailyAssignedTo, setDailyAssignedTo] = useState("");


// ========================================
// DAILY FOLLOW-UP REPORT
// ========================================
const [followUpData, setFollowUpData] = useState([]);
const [followUpLoading, setFollowUpLoading] = useState(false);

const [followUpFrom, setFollowUpFrom] = useState(today);
const [followUpTo, setFollowUpTo] = useState(today);
const [followUpAssignedTo, setFollowUpAssignedTo] = useState("");
const followUpTotals = followUpData.reduce(
  (total, row) => ({
    total_followups:
      total.total_followups + Number(row.total_followups || 0),

    unique_followups:
      total.unique_followups + Number(row.unique_followups || 0),

    repeat_followups:
      total.repeat_followups + Number(row.repeat_followups || 0),

    tasks_created:
      total.tasks_created + Number(row.tasks_created || 0),

    tasks_completed:
      total.tasks_completed + Number(row.tasks_completed || 0),

    office_meetings:
      total.office_meetings + Number(row.office_meetings || 0),

    site_visits:
      total.site_visits + Number(row.site_visits || 0),

    prospect_moved:
      total.prospect_moved + Number(row.prospect_moved || 0),

    drops_done:
      total.drops_done + Number(row.drops_done || 0),

    deals_created:
      total.deals_created + Number(row.deals_created || 0),
  }),
  {
    total_followups: 0,
    unique_followups: 0,
    repeat_followups: 0,
    tasks_created: 0,
    tasks_completed: 0,
    office_meetings: 0,
    site_visits: 0,
    prospect_moved: 0,
    drops_done: 0,
    deals_created: 0,
  }
);


// ========================================
// DAILY FOLLOW-UP DETAIL / AUDIT POPUP
// ========================================
const [followUpDetailOpen, setFollowUpDetailOpen] = useState(false);
const [followUpDetailLoading, setFollowUpDetailLoading] = useState(false);
const [followUpDetailData, setFollowUpDetailData] = useState([]);
const [followUpDetailCount, setFollowUpDetailCount] = useState(0);
const [followUpDetailManager, setFollowUpDetailManager] = useState("");
const [followUpDetailMetric, setFollowUpDetailMetric] = useState("");


const [salesManagers, setSalesManagers] = useState([]);

  useEffect(() => {
  if (!user) {
    return;
  }

  // Sales Manager ko global reports load nahi karni
 if (
  user.role === "sales_manager" ||
  user.role === "team_lead" ||
  user.role === "sales_head"
) {
  setLoading(false);
  return;
}

  Promise.all([
    getPipelineReport(),
    getForecastReport(),
    getSalespersonReport(),
    getSourceReport(),
    getCallStatsReport(),
  ])
    .then(([p, f, s, src, c]) =>
      setData({
        pipeline: p.data,
        forecast: f.data,
        salespeople: s.data,
        sources: src.data,
        callStats: c.data,
      })
    )
    .catch(console.error)
    .finally(() => setLoading(false));
}, [user]);


  useEffect(() => {
  if (!user) {
    return;
  }

  if (user.role === "sales_manager") {
    setSalesManagers([]);
    return;
  }

  getUsersApi()
  .then((res) => {
    const list = Array.isArray(res.data)
      ? res.data
      : [];

    const reportUsers = list.filter(
      (u) =>
        u.role === "sales_manager" ||
        u.role === "team_lead"
    );

    setSalesManagers(reportUsers);
  })
    .catch((err) => {
      console.error(
        "GET USERS ERROR:",
        err
      );
    });
}, [user]);

const loadDailyPerformance = async () => {
  try {
    setDailyLoading(true);

    const filters = {};

    if (dailyFrom) {
      filters.from = dailyFrom;
    }

    if (dailyTo) {
      filters.to = dailyTo;
    }

    if (dailyAssignedTo) {
      filters.assigned_to = dailyAssignedTo;
    }

    const response =
      await getDailySalesPerformance(filters);

    const rows = Array.isArray(response.data?.data)
  ? response.data.data
  : [];

const filteredRows = rows.filter((row) => {
  return (
    Number(row.leads_assigned || 0) > 0 ||
    Number(row.new_leads || 0) > 0 ||
    Number(row.inbound || 0) > 0 ||
    Number(row.prospect || 0) > 0 ||
    Number(row.meeting_done || 0) > 0 ||
    Number(row.site_visit || 0) > 0 ||
    Number(row.negotiation || 0) > 0 ||
    Number(row.dropped || 0) > 0 ||
    Number(row.active_leads || 0) > 0 ||
    Number(row.total_calls || 0) > 0 ||
    Number(row.total_call_minutes || 0) > 0 ||
    Number(row.total_followups || 0) > 0 ||
    Number(row.no_followup || 0) > 0 ||
    Number(row.completed_tasks || 0) > 0 ||
    Number(row.pending_tasks || 0) > 0 ||
    Number(row.overdue_tasks || 0) > 0 ||
    Number(row.deals || 0) > 0
  );
});

setDailyData(filteredRows);

  } catch (err) {
    console.error(
      "DAILY PERFORMANCE LOAD ERROR:",
      err
    );

    setDailyData([]);
  } finally {
    setDailyLoading(false);
  }
};

const loadDailyFollowUp = async () => {
  try {
    setFollowUpLoading(true);

    const filters = {};

    if (followUpFrom) {
      filters.from = followUpFrom;
    }

    if (followUpTo) {
      filters.to = followUpTo;
    }

    if (followUpAssignedTo) {
      filters.assigned_to = followUpAssignedTo;
    }

    const response =
      await getDailyFollowUp(filters);

    setFollowUpData(
      Array.isArray(response.data?.data)
        ? response.data.data
        : []
    );

  } catch (err) {
    console.error(
      "DAILY FOLLOW-UP LOAD ERROR:",
      err
    );

    setFollowUpData([]);
  } finally {
    setFollowUpLoading(false);
  }
};

const loadStageReport = async () => {
  try {
    setStageReportLoading(true);

    const filters = {};

    if (stageReportFrom) {
      filters.from = stageReportFrom;
    }

    if (stageReportTo) {
      filters.to = stageReportTo;
    }

    if (stageReportAssignedTo) {
      filters.assigned_to = stageReportAssignedTo;
    }

    const response = await getStageReport(filters);

    setStageReportData(
      Array.isArray(response.data?.data)
        ? response.data.data
        : []
    );

  } catch (err) {
    console.error(
      "STAGE REPORT LOAD ERROR:",
      err
    );

    setStageReportData([]);
  } finally {
    setStageReportLoading(false);
  }
};

const openDailyFollowUpDetails = async (
  row,
  metric
) => {
  try {
    setFollowUpDetailOpen(true);
    setFollowUpDetailLoading(true);
    setFollowUpDetailData([]);
    setFollowUpDetailCount(0);

    setFollowUpDetailManager(
      row.sales_manager || ""
    );

    setFollowUpDetailMetric(metric);

    const response =
      await getDailyFollowUpDetails({
        from: followUpFrom,
        to: followUpTo,
        sales_manager_id:
          row.sales_manager_id,
        metric,
      });

    setFollowUpDetailData(
      Array.isArray(response.data?.data)
        ? response.data.data
        : []
    );

    setFollowUpDetailCount(
      Number(response.data?.count || 0)
    );

  } catch (err) {
    console.error(
      "DAILY FOLLOW-UP DETAILS ERROR:",
      err
    );

    setFollowUpDetailData([]);
    setFollowUpDetailCount(0);

    alert(
      err.response?.data?.error ||
      "Could not load follow-up details"
    );

  } finally {
    setFollowUpDetailLoading(false);
  }
};


useEffect(() => {
  if (tab === "daily") {
    loadDailyPerformance();
  }

  if (tab === "stage-report") {
    loadStageReport();
  }

  if (tab === "daily-follow-up") {
    loadDailyFollowUp();
  }
}, [tab]);

  const SCOL = {'New Lead':'#888780','Contacted':'#378ADD','Qualified':'#BA7517','Site Visit Scheduled':'#9FE1CB','Site Visit Done':'#1D9E75','Negotiation':'#D4537E','Closed Won':'#639922','Closed Lost':'#E24B4A'};

  

const tabs =
 isSalesManager
  ? [
      {
        id: "daily",
        label: "Daily Performance",
      },
      {
        id: "daily-follow-up",
        label: "Daily Follow-up",
      },
    ]
        : isTeamLead || isSalesHead
    ? [
        {
          id: "daily",
          label: "Daily Performance",
        },
        {                                      
          id: "follow-up-gap",
          label: "Follow-up Gap",
        },
        {
          id: "daily-follow-up",
          label: "Daily Follow-up",
        },
      ]
    : [
        {
          id: "pipeline",
          label: "Pipeline",
        },
        {
          id: "stage-report",
          label: "Stage Report",
        },
                {
          id: "lead-aging",
          label: "Lead Aging",
        },
        {
          id: "follow-up-gap",
          label: "Follow-up Gap",
        },
        {
          id: "daily",
          label: "Daily Performance",
        },
        {
          id: "daily-follow-up",
          label: "Daily Follow-up",
        },
        {
          id: "forecast",
          label: "Forecast",
        },
        {
          id: "people",
          label: "Salespeople",
        },
        {
          id: "sources",
          label: "Sources",
        },
        {
          id: "calls",
          label: "Call Activity",
        },
      ];

const dailySummary = dailyData.reduce(
  (summary, row) => {
    summary.leads +=
      Number(row.leads_assigned || 0);

    summary.dropped +=
      Number(row.dropped || 0);

    summary.calls +=
      Number(row.total_calls || 0);

    summary.callMinutes +=
      Number(row.total_call_minutes || 0);

    summary.followups +=
      Number(row.total_followups || 0);

    summary.completedTasks +=
      Number(row.completed_tasks || 0);

    summary.pendingTasks +=
      Number(row.pending_tasks || 0);

    summary.overdueTasks +=
      Number(row.overdue_followups || 0);

    summary.deals +=
      Number(row.deals || 0);

    return summary;
  },
  {
    leads: 0,
    dropped: 0,
    calls: 0,
    callMinutes: 0,
    followups: 0,
    completedTasks: 0,
    pendingTasks: 0,
    overdueTasks: 0,
    deals: 0,
  }
);

const overallAvgCallDuration =
  dailySummary.calls > 0
    ? Math.round(
        (dailySummary.callMinutes * 60) /
          dailySummary.calls
      )
    : 0;

    const overallDropPercent =
  dailySummary.leads > 0
    ? (
        (dailySummary.dropped /
          dailySummary.leads) *
        100
      ).toFixed(1)
    : 0;

const overallTaskCompletionPercent =
  dailySummary.completedTasks + dailySummary.pendingTasks > 0
    ? (
        (dailySummary.completedTasks /
          (dailySummary.completedTasks +
            dailySummary.pendingTasks)) *
        100
      ).toFixed(1)
    : 0;
const dailyTotals = dailyData.reduce(
  (total, row) => ({
    leads: total.leads + Number(row.leads_assigned || 0),
    new_leads: total.new_leads + Number(row.new_leads || 0),
    inbound: total.inbound + Number(row.inbound || 0),
    prospect: total.prospect + Number(row.prospect || 0),
    meeting_done: total.meeting_done + Number(row.meeting_done || 0),
    site_visit: total.site_visit + Number(row.site_visit || 0),
    negotiation: total.negotiation + Number(row.negotiation || 0),
    dropped: total.dropped + Number(row.dropped || 0),
    active_leads: total.active_leads + Number(row.active_leads || 0),

    total_calls: total.total_calls + Number(row.total_calls || 0),
    total_call_minutes:
      total.total_call_minutes +
      Number(row.total_call_minutes || 0),

    total_followups:
      total.total_followups +
      Number(row.total_followups || 0),

    no_followup:
      total.no_followup + Number(row.no_followup || 0),

    completed_tasks:
      total.completed_tasks +
      Number(row.completed_tasks || 0),

    pending_tasks:
      total.pending_tasks +
      Number(row.pending_tasks || 0),

    overdue_followups:
      total.overdue_followups +
      Number(row.overdue_followups || 0),

    deals:
      total.deals + Number(row.deals || 0),
  }),
  {
    leads: 0,
    new_leads: 0,
    inbound: 0,
    prospect: 0,
    meeting_done: 0,
    site_visit: 0,
    negotiation: 0,
    dropped: 0,
    active_leads: 0,
    total_calls: 0,
    total_call_minutes: 0,
    total_followups: 0,
    no_followup: 0,
    completed_tasks: 0,
    pending_tasks: 0,
    overdue_followups: 0,
    deals: 0,
  }
);

const dailyTotalDropPercent =
  dailyTotals.leads > 0
    ? ((dailyTotals.dropped / dailyTotals.leads) * 100).toFixed(1)
    : 0;

const dailyTotalAvgCall =
  dailyTotals.total_calls > 0
    ? Math.round(
        (dailyTotals.total_call_minutes * 60) /
          dailyTotals.total_calls
      )
    : 0;

const dailyTotalAvgFollowups =
  dailyTotals.leads > 0
    ? (
        dailyTotals.total_followups /
        dailyTotals.leads
      ).toFixed(2)
    : 0;

const dailyTotalCompletionPercent =
  dailyTotals.completed_tasks +
    dailyTotals.pending_tasks >
  0
    ? (
        (dailyTotals.completed_tasks /
          (dailyTotals.completed_tasks +
            dailyTotals.pending_tasks)) *
        100
      ).toFixed(1)
    : 0;

const dailyTotalLeadToDealPercent =
  dailyTotals.leads > 0
    ? (
        (dailyTotals.deals /
          dailyTotals.leads) *
        100
      ).toFixed(1)
    : 0;
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>
      <div className="page-header">
  <div>
    <div className="page-title">
  {isSalesManager
    ? "My Performance"
    : isTeamLead
    ? "Daily Follow-up"
    : "Reports & Analytics"}
</div>

    {isSalesManager && (
      <div className="page-subtitle">
        Your personal lead, call and follow-up performance
      </div>
    )}
  </div>
</div>
      <div style={{ display:'flex', gap:'6px', padding:'10px 20px', background:'#fff', borderBottom:'0.5px solid rgba(0,0,0,0.08)', flexShrink:0 }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding:'5px 14px', borderRadius:'20px', border:'0.5px solid', fontSize:'12px', cursor:'pointer',
              background: tab===t.id ? '#1D9E75' : 'transparent', borderColor: tab===t.id ? '#1D9E75' : 'rgba(0,0,0,0.15)',
              color: tab===t.id ? '#fff' : '#666' }}>{t.label}</button>
        ))}
      </div>
      <div className="page-body">
        {tab === 'pipeline' && (
          <div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'10px', marginBottom:'20px' }}>
              {data.pipeline.map(s => (
                <div className="metric-card" key={s.stage}>
                  <div className="metric-label">{s.stage}</div>
                  <div className="metric-value">{s.count}</div>
                  <div className="metric-sub">₹{(s.total_value||0).toFixed(1)}Cr · {s.hot_count} hot</div>
                </div>
              ))}
            </div>
            <div className="card">
              <div style={{ fontSize:'13px', fontWeight:'600', marginBottom:'14px' }}>Leads per stage</div>
              <ResponsiveContainer width="100%" height={240}>
                <BarChart data={data.pipeline}>
                  <XAxis dataKey="stage" tick={{ fontSize:10 }} />
                  <YAxis tick={{ fontSize:11 }} />
                  <Tooltip />
                  <Bar dataKey="count" radius={[4,4,0,0]}>
                    {data.pipeline.map(s => <Cell key={s.stage} fill={SCOL[s.stage] || '#888'} />)}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}

        {tab === "stage-report" && (
  <div>

    {/* =========================
        FILTER BAR
    ========================== */}
    <div
      className="card"
      style={{
        marginBottom: 16,
        padding: 16,
        display: "flex",
        alignItems: "flex-end",
        gap: 12,
        flexWrap: "wrap",
      }}
    >

      {/* FROM DATE */}
      <div>
        <label
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 600,
            color: "#6B7280",
            marginBottom: 6,
            textTransform: "uppercase",
            letterSpacing: ".4px",
          }}
        >
          From Date
        </label>

        <input
          type="date"
          value={stageReportFrom}
          onChange={(e) =>
            setStageReportFrom(e.target.value)
          }
          style={{
            height: 38,
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "0 10px",
            background: "#fff",
          }}
        />
      </div>


      {/* TO DATE */}
      <div>
        <label
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 600,
            color: "#6B7280",
            marginBottom: 6,
            textTransform: "uppercase",
            letterSpacing: ".4px",
          }}
        >
          To Date
        </label>

        <input
          type="date"
          value={stageReportTo}
          onChange={(e) =>
            setStageReportTo(e.target.value)
          }
          style={{
            height: 38,
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "0 10px",
            background: "#fff",
          }}
        />
      </div>


      {/* SALES MANAGER / TEAM LEAD */}
      {!isSalesManager && (
        <div>
          <label
            style={{
              display: "block",
              fontSize: 11,
              fontWeight: 600,
              color: "#6B7280",
              marginBottom: 6,
              textTransform: "uppercase",
              letterSpacing: ".4px",
            }}
          >
            Sales Manager
          </label>

          <select
            value={stageReportAssignedTo}
            onChange={(e) =>
              setStageReportAssignedTo(e.target.value)
            }
            style={{
              height: 38,
              minWidth: 200,
              border: "1px solid #E5E7EB",
              borderRadius: 8,
              padding: "0 10px",
              background: "#fff",
            }}
          >
            <option value="">
              All Sales Managers / Team Leads
            </option>

            {salesManagers.map((manager) => (
              <option
                key={manager.id}
                value={manager.id}
              >
                {manager.name}
              </option>
            ))}
          </select>
        </div>
      )}


      {/* APPLY FILTER */}
      <button
        type="button"
        onClick={loadStageReport}
        disabled={stageReportLoading}
        style={{
          height: 38,
          padding: "0 22px",
          border: "none",
          borderRadius: 8,
          background: "#1D9E75",
          color: "#fff",
          fontWeight: 600,
          cursor: stageReportLoading
            ? "not-allowed"
            : "pointer",
          opacity: stageReportLoading ? 0.7 : 1,
        }}
      >
        {stageReportLoading
          ? "Loading..."
          : "Apply Filters"}
      </button>

    </div>


    {/* =========================
        STAGE REPORT TABLE
    ========================== */}
    <div
      className="card"
      style={{
        padding: 0,
        overflow: "hidden",
      }}
    >

      {/* HEADER */}
      <div
        style={{
          padding: "14px 16px",
          borderBottom: "1px solid #F0F0F0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>

          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            Stage Movement Report
          </div>

          <div
            style={{
              fontSize: 11,
              color: "#9CA3AF",
              marginTop: 2,
            }}
          >
            Lead stage movement during selected period
          </div>

        </div>

        <div
          style={{
            fontSize: 11,
            color: "#6B7280",
          }}
        >
          {stageReportData.length} Sales Managers / Team Leads
        </div>

      </div>


      {/* TABLE */}
      <div
        style={{
          overflowX: "auto",
        }}
      >

        {stageReportLoading ? (

          <div
            style={{
              padding: 40,
              textAlign: "center",
              color: "#6B7280",
            }}
          >
            Loading stage report...
          </div>

        ) : (

          <table
            style={{
              width: "100%",
              minWidth: 1400,
              borderCollapse: "collapse",
            }}
          >

            <thead>

              <tr
                style={{
                  background: "#F9FAFB",
                }}
              >

                <th
                  style={{
                    padding: "12px 14px",
                    textAlign: "left",
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#6B7280",
                    borderBottom: "1px solid #E5E7EB",
                    position: "sticky",
                    left: 0,
                    background: "#F9FAFB",
                    zIndex: 2,
                  }}
                >
                  Sales Manager / Team Lead
                </th>

                <th className="report-th">New Lead</th>
                <th className="report-th">Inbound</th>
                <th className="report-th">Contacted</th>
                <th className="report-th">Prospect</th>
                <th className="report-th">Qualified</th>
                <th className="report-th">DNP</th>
                <th className="report-th">Meeting Done</th>
                <th className="report-th">Site Visit</th>
                <th className="report-th">Negotiation</th>
                <th className="report-th">Closed Won</th>
                <th className="report-th">Closed Lost</th>

              </tr>

            </thead>


            <tbody>

              {stageReportData.length === 0 ? (

                <tr>

                  <td
                    colSpan={12}
                    style={{
                      padding: 40,
                      textAlign: "center",
                      color: "#9CA3AF",
                    }}
                  >
                    No stage movement found for selected period.
                  </td>

                </tr>

              ) : (

                stageReportData.map((row) => (

                  <tr key={row.sales_manager_id}>

                    <td
                      style={{
                        padding: "12px 14px",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#111827",
                        borderBottom: "1px solid #F0F0F0",
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 1,
                      }}
                    >
                      {row.sales_manager}
                    </td>


                    {[
                      "new_lead",
                      "inbound",
                      "contacted",
                      "prospect",
                      "qualified",
                      "dnp",
                      "meeting_done",
                      "site_visit",
                      "negotiation",
                      "closed_won",
                      "closed_lost",
                    ].map((key) => (

                      <td
                        key={key}
                        style={{
                          padding: "12px 14px",
                          textAlign: "center",
                          fontSize: 12,
                          fontWeight: 600,
                          color: "#111827",
                          borderBottom: "1px solid #F0F0F0",
                        }}
                      >
                        {Number(row[key] || 0)}
                      </td>

                    ))}

                  </tr>

                ))

              )}

            </tbody>

          </table>

        )}

      </div>

    </div>

  </div>
)}

{tab === "lead-aging" && (
  <LeadAging
    salesManagers={salesManagers}
    isSalesManager={isSalesManager}
  />
)}

{tab === "follow-up-gap" && (                   
  <FollowUpGap
    salesManagers={salesManagers}
    isSalesManager={isSalesManager}
  />
)}

        {tab === "daily" && (
  <div>

    {/* =========================
        FILTER BAR
    ========================== */}
    <div
      className="card"
      style={{
        marginBottom: 16,
        padding: 16,
        display: "flex",
        alignItems: "flex-end",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <div>
        <label
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 600,
            color: "#6B7280",
            marginBottom: 6,
            textTransform: "uppercase",
            letterSpacing: ".4px",
          }}
        >
          From Date
        </label>

        <input
          type="date"
          value={dailyFrom}
          onChange={(e) =>
            setDailyFrom(e.target.value)
          }
          style={{
            height: 38,
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "0 10px",
            background: "#fff",
          }}
        />
      </div>

      <div>
        <label
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 600,
            color: "#6B7280",
            marginBottom: 6,
            textTransform: "uppercase",
            letterSpacing: ".4px",
          }}
        >
          To Date
        </label>

        <input
          type="date"
          value={dailyTo}
          onChange={(e) =>
            setDailyTo(e.target.value)
          }
          style={{
            height: 38,
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "0 10px",
            background: "#fff",
          }}
        />
      </div>

      {!isSalesManager && (
  <div>
    <label
      style={{
        display: "block",
        fontSize: 11,
        fontWeight: 600,
        color: "#6B7280",
        marginBottom: 6,
        textTransform: "uppercase",
        letterSpacing: ".4px",
      }}
    >
      Sales Manager
    </label>

    <select
      value={dailyAssignedTo}
      onChange={(e) =>
        setDailyAssignedTo(e.target.value)
      }
      style={{
        height: 38,
        minWidth: 200,
        border: "1px solid #E5E7EB",
        borderRadius: 8,
        padding: "0 10px",
        background: "#fff",
      }}
    >
      <option value="">
  All Sales Managers / Team Leads
</option>

      {salesManagers.map((manager) => (
        <option
          key={manager.id}
          value={manager.id}
        >
          {manager.name}
        </option>
      ))}
    </select>
  </div>
)}

      <button
        type="button"
        onClick={loadDailyPerformance}
        disabled={dailyLoading}
        style={{
          height: 38,
          padding: "0 22px",
          border: "none",
          borderRadius: 8,
          background: "#1D9E75",
          color: "#fff",
          fontWeight: 600,
          cursor: dailyLoading
            ? "not-allowed"
            : "pointer",
          opacity: dailyLoading ? 0.7 : 1,
        }}
      >
        {dailyLoading
          ? "Loading..."
          : "Apply Filters"}
      </button>
    </div>


    {/* =========================
        MANAGEMENT KPI CARDS
    ========================== */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns:
          "repeat(auto-fit, minmax(150px, 1fr))",
        gap: 10,
        marginBottom: 16,
      }}
    >
      <div className="metric-card">
        <div className="metric-label">
          Total Leads
        </div>

        <div className="metric-value">
          {dailySummary.leads}
        </div>

        <div className="metric-sub">
          Selected period
        </div>
      </div>


      <div className="metric-card">
        <div className="metric-label">
          Drop Rate
        </div>

        <div
          className="metric-value"
          style={{
            color:
              Number(overallDropPercent) > 50
                ? "#DC2626"
                : "#111827",
          }}
        >
          {overallDropPercent}%
        </div>

        <div className="metric-sub">
          {dailySummary.dropped} dropped
        </div>
      </div>


      <div className="metric-card">
        <div className="metric-label">
          Total Follow-ups
        </div>

        <div className="metric-value">
          {dailySummary.followups}
        </div>

        <div className="metric-sub">
          Tasks / follow-ups created
        </div>
      </div>

      <div className="metric-card">
  <div className="metric-label">
    Calls Made
  </div>

  <div
    className="metric-value"
    style={{ color: "#2563EB" }}
  >
    {dailySummary.calls}
  </div>

  <div className="metric-sub">
    Selected period
  </div>
</div>

<div className="metric-card">
  <div className="metric-label">
    Call Time
  </div>

  <div className="metric-value">
    {dailySummary.callMinutes.toFixed(1)}m
  </div>

  <div className="metric-sub">
    Total conversation time
  </div>
</div>

<div className="metric-card">
  <div className="metric-label">
    Avg Call Duration
  </div>

  <div className="metric-value">
    {overallAvgCallDuration}s
  </div>

  <div className="metric-sub">
    Average per call
  </div>
</div>



      <div className="metric-card">
        <div className="metric-label">
          Task Completion
        </div>

        <div
          className="metric-value"
          style={{
            color: "#1D9E75",
          }}
        >
          {overallTaskCompletionPercent}%
        </div>

        <div className="metric-sub">
          {dailySummary.completedTasks} completed
        </div>
      </div>


      <div className="metric-card">
        <div className="metric-label">
          Pending Tasks
        </div>

        <div className="metric-value">
          {dailySummary.pendingTasks}
        </div>

        <div className="metric-sub">
          Awaiting action
        </div>
      </div>


      <div className="metric-card">
        <div className="metric-label">
          Overdue Tasks
        </div>

        <div
          className="metric-value"
          style={{
            color:
              dailySummary.overdueTasks > 0
                ? "#DC2626"
                : "#1D9E75",
          }}
        >
          {dailySummary.overdueTasks}
        </div>

        <div className="metric-sub">
          Requires attention
        </div>
      </div>


      <div className="metric-card">
        <div className="metric-label">
          Deals
        </div>

        <div
          className="metric-value"
          style={{
            color: "#1D9E75",
          }}
        >
          {dailySummary.deals}
        </div>

        <div className="metric-sub">
          Lead conversions
        </div>
      </div>
    </div>


    {/* =========================
        PERFORMANCE TABLE
    ========================== */}
    <div
      className="card"
      style={{
        padding: 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "14px 16px",
          borderBottom: "1px solid #F0F0F0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            Sales Manager Performance
          </div>

          <div
            style={{
              fontSize: 11,
              color: "#9CA3AF",
              marginTop: 2,
            }}
          >
            Lead movement, follow-up discipline
            and task performance
          </div>
        </div>

        <div
          style={{
            fontSize: 11,
            color: "#6B7280",
          }}
        >
          {dailyData.length} Sales Managers / Team Leads
        </div>
      </div>


      <div
        style={{
          overflowX: "auto",
        }}
      >
        {dailyLoading ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
              color: "#6B7280",
            }}
          >
            Loading performance report...
          </div>
        ) : (
          <table
            style={{
              width: "100%",
              minWidth: 2200,
              borderCollapse: "collapse",
            }}
          >
            <thead>

              {/* GROUP HEADINGS */}
              <tr
                style={{
                  background: "#F9FAFB",
                }}
              >
                <th
                  rowSpan="2"
                  style={{
                    position: "sticky",
                    left: 0,
                    zIndex: 5,
                    background: "#F9FAFB",
                    minWidth: 170,
                    textAlign: "left",
                  }}
                >
                  Sales Manager
                </th>

                <th
                  colSpan="11"
                  style={{
                    textAlign: "center",
                    color: "#374151",
                    fontWeight: 700,
                  }}
                >
                  Lead Performance
                </th>
<th
  colSpan="3"
  style={{
    textAlign: "center",
    color: "#374151",
    fontWeight: 700,
  }}
>
  Call Performance
</th>
                <th
                  colSpan="7"
                  style={{
                    textAlign: "center",
                    color: "#374151",
                    fontWeight: 700,
                  }}
                >
                  Follow-up & Task Performance
                </th>

                <th
                  colSpan="2"
                  style={{
                    textAlign: "center",
                    color: "#374151",
                    fontWeight: 700,
                  }}
                >
                  Conversion
                </th>
              </tr>


              {/* COLUMN HEADINGS */}
              <tr
                style={{
                  background: "#FAFAFA",
                }}
              >
                <th>Leads</th>
                <th>New</th>
                <th>Inbound</th>
                <th>Prospect</th>
                <th>Meeting</th>
                <th>Site Visit</th>
                <th>Negotiation</th>
                <th>Drop</th>
                <th>Drop %</th>
                <th>Active</th>
                <th>Untouched</th>
                <th>Calls</th>
<th>Call Time</th>
<th>Avg Call</th>

                <th>Total Follow-ups</th>
                <th>Avg / Lead</th>
                <th>No Follow-up</th>
                <th>Completed</th>
                <th>Pending</th>
                <th>Overdue</th>
                <th>Completion %</th>

                <th>Deals</th>
                <th>Lead → Deal %</th>
              </tr>
            </thead>


            <tbody>
              {dailyData.length === 0 ? (
                <tr>
                  <td
                    colSpan="24"
                    style={{
                      textAlign: "center",
                      padding: 40,
                      color: "#9CA3AF",
                    }}
                  >
                    No performance data found
                    for selected period
                  </td>
                </tr>
              ) : (
  <>
    {/* TOTAL ROW */}
    <tr
      style={{
        background: "#F3F4F6",
        borderBottom: "2px solid #D1D5DB",
        fontWeight: 700,
      }}
    >
      <td
        style={{
          position: "sticky",
          left: 0,
          background: "#F3F4F6",
          zIndex: 3,
          fontWeight: 800,
          color: "#111827",
          whiteSpace: "nowrap",
        }}
      >
        Total
      </td>

      <td>{dailyTotals.leads}</td>
      <td>{dailyTotals.new_leads}</td>
      <td>{dailyTotals.inbound}</td>
      <td>{dailyTotals.prospect}</td>
      <td>{dailyTotals.meeting_done}</td>
      <td>{dailyTotals.site_visit}</td>
      <td>{dailyTotals.negotiation}</td>
      <td>{dailyTotals.dropped}</td>

      <td>
        {dailyTotalDropPercent}%
      </td>

      <td>{dailyTotals.active_leads}</td>
      <td
  style={{
    fontWeight: 700,
    color: "#DC2626",
  }}
>
  {dailyData.reduce(
    (sum, r) => sum + Number(r.untouched_leads || 0),
    0
  )}
</td>

      <td
        style={{
          fontWeight: 700,
          color: "#2563EB",
        }}
      >
        {dailyTotals.total_calls}
      </td>

      <td>
        {Number(
          dailyTotals.total_call_minutes
        ).toFixed(1)}
        m
      </td>

      <td>
        {dailyTotalAvgCall}s
      </td>

      <td>
        {dailyTotals.total_followups}
      </td>

      <td>
        {dailyTotalAvgFollowups}
      </td>

      <td>
        {dailyTotals.no_followup}
      </td>

      <td>
        {dailyTotals.completed_tasks}
      </td>

      <td>
        {dailyTotals.pending_tasks}
      </td>

      <td>
        {dailyTotals.overdue_followups}
      </td>

      <td>
        {dailyTotalCompletionPercent}%
      </td>

      <td
        style={{
          color: "#1D9E75",
          fontWeight: 700,
        }}
      >
        {dailyTotals.deals}
      </td>

      <td>
        {dailyTotalLeadToDealPercent}%
      </td>
    </tr>

    {/* USER ROWS */}
    {dailyData.map((row) => (
                  <tr
                    key={row.sales_manager_id}
                    style={{
                      borderBottom:
                        "1px solid #F3F4F6",
                    }}
                  >
                    {/* SALES MANAGER */}
                    <td
                      style={{
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 3,
                        fontWeight: 700,
                        color: "#111827",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {row.sales_manager}
                    </td>


                    {/* LEADS */}
                    <td
                      style={{
                        fontWeight: 700,
                      }}
                    >
                      {row.leads_assigned || 0}
                    </td>

                    <td>
                      {row.new_leads || 0}
                    </td>

                    <td>
                      {row.inbound || 0}
                    </td>

                    <td>
                      {row.prospect || 0}
                    </td>

                    <td>
                      {row.meeting_done || 0}
                    </td>

                    <td>
                      {row.site_visit || 0}
                    </td>

                    <td>
                      {row.negotiation || 0}
                    </td>


                    {/* DROP */}
                    <td>
                      {row.dropped || 0}
                    </td>

                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          minWidth: 48,
                          padding: "3px 7px",
                          borderRadius: 20,
                          fontSize: 11,
                          fontWeight: 700,

                          background:
                            Number(
                              row.drop_percent
                            ) > 50
                              ? "#FEF2F2"
                              : "#F3F4F6",

                          color:
                            Number(
                              row.drop_percent
                            ) > 50
                              ? "#DC2626"
                              : "#374151",
                        }}
                      >
                        {row.drop_percent || 0}%
                      </span>
                    </td>


                    <td>
  {row.active_leads || 0}
</td>
<td
  style={{
    fontWeight: 700,
    color:
      Number(row.untouched_leads) > 0
        ? "#DC2626"
        : "#15803D",
  }}
>
  {row.untouched_leads || 0}
</td>


{/* CALL PERFORMANCE */}
<td
  style={{
    fontWeight: 700,
    color: "#2563EB",
  }}
>
  {row.total_calls || 0}
</td>

<td>
  {Number(
    row.total_call_minutes || 0
  ).toFixed(1)}
  m
</td>

<td>
  {Math.round(
    Number(
      row.avg_call_duration_seconds || 0
    )
  )}
  s
</td>


{/* FOLLOW UPS */}
                    <td
                      style={{
                        fontWeight: 600,
                      }}
                    >
                      {row.total_followups || 0}
                    </td>

                    <td>
                      {row.avg_followups_per_lead ||
                        0}
                    </td>

                    <td>
                      {row.no_followup || 0}
                    </td>
     

                    {/* TASKS */}
                    <td>
                      <span
                        style={{
                          color: "#15803D",
                          fontWeight: 700,
                        }}
                      >
                        {row.completed_tasks || 0}
                      </span>
                    </td>

                    <td>
                      <span
                        style={{
                          color: "#B45309",
                          fontWeight: 700,
                        }}
                      >
                        {row.pending_tasks || 0}
                      </span>
                    </td>

                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          minWidth: 32,
                          padding: "3px 7px",
                          borderRadius: 20,
                          fontSize: 11,
                          fontWeight: 700,

                          background:
                            Number(
                              row.overdue_followups
                            ) > 0
                              ? "#FEF2F2"
                              : "#ECFDF5",

                          color:
                            Number(
                              row.overdue_followups
                            ) > 0
                              ? "#DC2626"
                              : "#15803D",
                        }}
                      >
                        {row.overdue_followups || 0}
                      </span>
                    </td>


                    {/* COMPLETION */}
                    <td>
                      <span
                        style={{
                          display: "inline-block",
                          minWidth: 55,
                          padding: "3px 7px",
                          borderRadius: 20,
                          fontSize: 11,
                          fontWeight: 700,

                          background:
                            Number(
                              row.task_completion_percent
                            ) >= 80
                              ? "#ECFDF5"
                              : Number(
                                  row.task_completion_percent
                                ) >= 50
                              ? "#FFFBEB"
                              : "#FEF2F2",

                          color:
                            Number(
                              row.task_completion_percent
                            ) >= 80
                              ? "#15803D"
                              : Number(
                                  row.task_completion_percent
                                ) >= 50
                              ? "#B45309"
                              : "#DC2626",
                        }}
                      >
                        {row.task_completion_percent ||
                          0}
                        %
                      </span>
                    </td>


                    {/* DEAL */}
                    <td
                      style={{
                        color: "#1D9E75",
                        fontWeight: 700,
                      }}
                    >
                      {row.deals || 0}
                    </td>

                    <td
                      style={{
                        fontWeight: 600,
                      }}
                    >
                      {row.lead_to_deal_percent ||
                        0}
                      %
                    </td>
                  </tr>
                                ))}
              </>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </div>
)}


{tab === "daily-follow-up" && (
  <div>

    {/* =========================
        FILTER BAR
    ========================== */}
    <div
      className="card"
      style={{
        marginBottom: 16,
        padding: 16,
        display: "flex",
        alignItems: "flex-end",
        gap: 12,
        flexWrap: "wrap",
      }}
    >

      <div>
        <label
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 600,
            color: "#6B7280",
            marginBottom: 6,
            textTransform: "uppercase",
            letterSpacing: ".4px",
          }}
        >
          From Date
        </label>

        <input
          type="date"
          value={followUpFrom}
          onChange={(e) =>
            setFollowUpFrom(e.target.value)
          }
          style={{
            height: 38,
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "0 10px",
            background: "#fff",
          }}
        />
      </div>


      <div>
        <label
          style={{
            display: "block",
            fontSize: 11,
            fontWeight: 600,
            color: "#6B7280",
            marginBottom: 6,
            textTransform: "uppercase",
            letterSpacing: ".4px",
          }}
        >
          To Date
        </label>

        <input
          type="date"
          value={followUpTo}
          onChange={(e) =>
            setFollowUpTo(e.target.value)
          }
          style={{
            height: 38,
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "0 10px",
            background: "#fff",
          }}
        />
      </div>


      {!isSalesManager && !isTeamLead && (
        <div>
          <label
            style={{
              display: "block",
              fontSize: 11,
              fontWeight: 600,
              color: "#6B7280",
              marginBottom: 6,
              textTransform: "uppercase",
              letterSpacing: ".4px",
            }}
          >
            Sales Manager
          </label>

          <select
            value={followUpAssignedTo}
            onChange={(e) =>
              setFollowUpAssignedTo(e.target.value)
            }
            style={{
              height: 38,
              minWidth: 200,
              border: "1px solid #E5E7EB",
              borderRadius: 8,
              padding: "0 10px",
              background: "#fff",
            }}
          >
            <option value="">
              All Sales Managers / Team Leads
            </option>

            {salesManagers.map((manager) => (
              <option
                key={manager.id}
                value={manager.id}
              >
                {manager.name}
              </option>
            ))}
          </select>
        </div>
      )}


      <button
        type="button"
        onClick={loadDailyFollowUp}
        disabled={followUpLoading}
        style={{
          height: 38,
          padding: "0 22px",
          border: "none",
          borderRadius: 8,
          background: "#1D9E75",
          color: "#fff",
          fontWeight: 600,
          cursor: followUpLoading
            ? "not-allowed"
            : "pointer",
          opacity: followUpLoading ? 0.7 : 1,
        }}
      >
        {followUpLoading
          ? "Loading..."
          : "Apply Filters"}
      </button>
    </div>


    {/* =========================
        REPORT TABLE
    ========================== */}
    <div
      className="card"
      style={{
        padding: 0,
        overflow: "hidden",
      }}
    >

      <div
        style={{
          padding: "14px 16px",
          borderBottom: "1px solid #F0F0F0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            Daily Follow-up Activity
          </div>

          <div
            style={{
              fontSize: 11,
              color: "#9CA3AF",
              marginTop: 2,
            }}
          >
            Actual CRM activity performed during the selected period
          </div>
        </div>

        <div
          style={{
            fontSize: 11,
            color: "#6B7280",
          }}
        >
          {followUpData.length} Users
        </div>
      </div>


      <div style={{ overflowX: "auto" }}>
        {followUpLoading ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
              color: "#6B7280",
            }}
          >
            Loading daily follow-up report...
          </div>
        ) : (
          <table
            style={{
              width: "100%",
              minWidth: 1450,
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#F9FAFB",
                }}
              >
                <th
                  style={{
                    position: "sticky",
                    left: 0,
                    zIndex: 5,
                    background: "#F9FAFB",
                    minWidth: 180,
                    textAlign: "left",
                  }}
                >
                  Sales Manager / Team Lead
                </th>

                <th style={{ textAlign: "center" }}>Total Follow-ups</th>
<th style={{ textAlign: "center" }}>Unique Follow-ups</th>
<th style={{ textAlign: "center" }}>Repeat Follow-ups</th>
<th style={{ textAlign: "center" }}>Tasks Created</th>
<th style={{ textAlign: "center" }}>Tasks Completed</th>
<th style={{ textAlign: "center" }}>Office Meetings</th>
<th style={{ textAlign: "center" }}>Site Visits</th>
<th style={{ textAlign: "center" }}>Prospect Moved</th>
<th style={{ textAlign: "center" }}>Drops Done</th>
<th style={{ textAlign: "center" }}>Deals Created</th>
              </tr>
            </thead>

            <tbody>
              {followUpData.length === 0 ? (
                <tr>
                  <td
                    colSpan="11"
                    style={{
                      textAlign: "center",
                      padding: 40,
                      color: "#9CA3AF",
                    }}
                  >
                    No follow-up activity found
                    for selected period
                  </td>
                </tr>
              ) : (
  <>
    {/* TOTAL ROW */}
    <tr
      style={{
        background: "#F3F4F6",
        borderBottom: "2px solid #D1D5DB",
        fontWeight: 700,
      }}
    >
      <td
        style={{
          position: "sticky",
          left: 0,
          background: "#F3F4F6",
          zIndex: 3,
          fontWeight: 800,
          color: "#111827",
        }}
      >
        Total
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.total_followups}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.unique_followups}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.repeat_followups}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.tasks_created}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.tasks_completed}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.office_meetings}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.site_visits}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.prospect_moved}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.drops_done}
      </td>

      <td style={{ textAlign: "center" }}>
        {followUpTotals.deals_created}
      </td>
    </tr>

    {followUpData.map((row) => (
                  <tr
                    key={row.sales_manager_id}
                    style={{
                      borderBottom:
                        "1px solid #F3F4F6",
                    }}
                  >

                    <td
                      style={{
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 3,
                        fontWeight: 700,
                        color: "#111827",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {row.sales_manager}
                    </td>

                    <td
  style={{
    textAlign: "center",
    fontWeight: 700,
  }}
>
  <button
    type="button"
    onClick={() =>
      openDailyFollowUpDetails(
        row,
        "total_followups"
      )
    }
    style={{
      border: "none",
      background: "transparent",
      padding: 0,
      color: "#1D9E75",
      fontWeight: 700,
      cursor: "pointer",
      textDecoration: "underline",
      fontSize: "inherit",
    }}
    title="View follow-up details"
  >
    {row.total_followups || 0}
  </button>
</td>

<td style={{ textAlign: "center" }}>
  <button
    type="button"
    onClick={() =>
      openDailyFollowUpDetails(
        row,
        "unique_followups"
      )
    }
    style={{
      border: "none",
      background: "transparent",
      padding: 0,
      color: "#1D9E75",
      fontWeight: 700,
      cursor: "pointer",
      textDecoration: "underline",
      fontSize: "inherit",
    }}
    title="View Unique Follow-up details"
  >
    {row.unique_followups || 0}
  </button>
</td>

<td style={{ textAlign: "center" }}>
  {row.repeat_followups || 0}
</td>

<td style={{ textAlign: "center" }}>
  {row.tasks_created || 0}
</td>

<td style={{ textAlign: "center" }}>
  {row.tasks_completed || 0}
</td>

<td style={{ textAlign: "center" }}>
  {row.office_meetings || 0}
</td>

<td style={{ textAlign: "center" }}>
  {row.site_visits || 0}
</td>

<td style={{ textAlign: "center" }}>
  <button
    type="button"
    onClick={() =>
      openDailyFollowUpDetails(
        row,
        "prospect_moved"
      )
    }
    style={{
      border: "none",
      background: "transparent",
      padding: 0,
      color: "#1D9E75",
      fontWeight: 700,
      cursor: "pointer",
      textDecoration: "underline",
      fontSize: "inherit",
    }}
    title="View Prospect Moved details"
  >
    {row.prospect_moved || 0}
  </button>
</td>

<td style={{ textAlign: "center" }}>
  {row.drops_done || 0}
</td>

<td
  style={{
    textAlign: "center",
    fontWeight: 700,
    color: "#1D9E75",
  }}
>
    {row.deals_created || 0}
</td>

                                    </tr>
                ))}
  </>
)}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </div>
)}
{followUpDetailOpen && (
  <div
    onClick={() => setFollowUpDetailOpen(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      zIndex: 10000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "min(1100px, 95vw)",
        maxHeight: "85vh",
        background: "#fff",
        borderRadius: 14,
        boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: "16px 20px",
          borderBottom: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 16,
              fontWeight: 700,
              color: "#111827",
            }}
          >
            {followUpDetailManager} —{" "}
{followUpDetailMetric === "prospect_moved"
  ? "Prospect Moved"
  : followUpDetailMetric === "unique_followups"
  ? "Unique Follow-ups"
  : "Total Follow-ups"}
          </div>

          <div
            style={{
              fontSize: 12,
              color: "#6B7280",
              marginTop: 4,
            }}
          >
            {followUpFrom} to {followUpTo} · {followUpDetailCount} activities
          </div>
        </div>

        <button
          type="button"
          onClick={() => setFollowUpDetailOpen(false)}
          style={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            border: "1px solid #E5E7EB",
            background: "#fff",
            cursor: "pointer",
            fontSize: 20,
          }}
        >
          ×
        </button>
      </div>

      <div style={{ overflow: "auto", flex: 1 }}>
        {followUpDetailLoading ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
              color: "#6B7280",
            }}
          >
            Loading details...
          </div>
        ) : followUpDetailData.length === 0 ? (
          <div
            style={{
              padding: 40,
              textAlign: "center",
              color: "#6B7280",
            }}
          >
            No follow-up activity found.
          </div>
        ) : (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: 13,
            }}
          >
            <thead>
              <tr style={{ background: "#F9FAFB" }}>
                <th style={{ padding: 12, textAlign: "left" }}>Lead Name</th>
                <th style={{ padding: 12, textAlign: "left" }}>Phone</th>
                <th style={{ padding: 12, textAlign: "left" }}>Stage</th>
                <th style={{ padding: 12, textAlign: "left" }}>Comment</th>
                <th style={{ padding: 12, textAlign: "left" }}>Activity Time</th>
              </tr>
            </thead>

            <tbody>
              {followUpDetailData.map((item) => (
                <tr key={item.activity_id}>
                  <td style={{ padding: 12, borderTop: "1px solid #eee" }}>
                    {item.lead_name || "-"}
                  </td>

                  <td style={{ padding: 12, borderTop: "1px solid #eee" }}>
                    {item.lead_phone || "-"}
                  </td>

                  <td style={{ padding: 12, borderTop: "1px solid #eee" }}>
                    {item.current_stage || "-"}
                  </td>

                  <td style={{ padding: 12, borderTop: "1px solid #eee" }}>
                    {item.comment || "-"}
                  </td>

                  <td style={{ padding: 12, borderTop: "1px solid #eee" }}>
                    {item.activity_at
                      ? new Date(item.activity_at).toLocaleString("en-IN")
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </div>
)}

{tab === 'forecast' && (
          <div style={{ maxWidth:'500px' }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'10px', marginBottom:'16px' }}>
              <div className="metric-card"><div className="metric-label">Closed revenue</div><div className="metric-value">₹{(data.forecast.closed_revenue||0).toFixed(2)}Cr</div></div>
              <div className="metric-card"><div className="metric-label">Weighted forecast</div><div className="metric-value" style={{ color:'#BA7517' }}>₹{(data.forecast.weighted_forecast||0).toFixed(2)}Cr</div></div>
              <div className="metric-card"><div className="metric-label">Total pipeline</div><div className="metric-value">₹{(data.forecast.total_pipeline||0).toFixed(2)}Cr</div></div>
            </div>
            <div className="card">
              <div style={{ fontSize:'13px', fontWeight:'600', marginBottom:'14px' }}>Revenue by stage (probability-weighted)</div>
              {(data.forecast.by_stage||[]).map(s => {
                const w = {'New Lead':0.05,'Contacted':0.1,'Qualified':0.2,'Site Visit Scheduled':0.3,'Site Visit Done':0.5,'Negotiation':0.75,'Closed Won':1,'Closed Lost':0};
                const weighted = (s.total_value || 0) * (w[s.stage] || 0);
                return (
                  <div key={s.stage} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:'0.5px solid rgba(0,0,0,0.06)', fontSize:'13px' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                      <span className="stage-dot" style={{ background: SCOL[s.stage] }} />{s.stage} <span style={{ color:'#aaa', fontSize:'11px' }}>({s.count})</span>
                    </div>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ color:'#1D9E75', fontWeight:600 }}>₹{weighted.toFixed(2)}Cr</div>
                      <div style={{ color:'#aaa', fontSize:'11px' }}>of ₹{(s.total_value||0).toFixed(2)}Cr pipeline</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        
        {tab === 'people' && (
          <div style={{ overflowX:'auto' }}>
            <table>
              <thead><tr>
                <th>Salesperson</th><th>Total Leads</th><th>Closed Won</th><th>In Negotiation</th>
                <th>Site Visits</th><th>Revenue Closed</th><th>Total Calls</th><th>Call Time</th><th>Follow-ups</th>
              </tr></thead>
              <tbody>
                {data.salespeople.map(s => (
                  <tr key={s.id}>
                    <td style={{ fontWeight:600 }}>{s.name}</td>
                    <td>{s.total_leads}</td>
                    <td><span style={{ color:'#639922', fontWeight:600 }}>{s.closed_won}</span></td>
                    <td>{s.in_negotiation}</td>
                    <td>{s.site_visits}</td>
                    <td style={{ color:'#1D9E75', fontWeight:600 }}>₹{(s.revenue_closed||0).toFixed(2)}Cr</td>
                    <td>{s.total_calls}</td>
                    <td>{s.total_call_seconds > 0 ? `${Math.round(s.total_call_seconds/60)}m` : '—'}</td>
                    <td>{s.total_followups}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {tab === 'sources' && (
          <div style={{ overflowX:'auto' }}>
            <table>
              <thead><tr><th>Source</th><th>Campaign</th><th>Leads</th><th>Conversions</th><th>Conversion %</th><th>Revenue</th></tr></thead>
              <tbody>
                {data.sources.map((s,i) => (
                  <tr key={i}>
                    <td style={{ fontWeight:600 }}>{s.source}</td>
                    <td style={{ fontSize:'11px', color:'#888' }}>{s.campaign_name || '—'}</td>
                    <td>{s.count}</td>
                    <td style={{ color:'#639922', fontWeight:600 }}>{s.conversions}</td>
                    <td>{s.conversion_rate || 0}%</td>
                    <td style={{ color:'#1D9E75', fontWeight:600 }}>₹{(s.revenue||0).toFixed(2)}Cr</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {tab === 'calls' && (
          <div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'10px', marginBottom:'16px' }}>
              <div className="metric-card"><div className="metric-label">Total calls</div><div className="metric-value">{data.callStats.reduce((s,r)=>s+(r.total_calls||0),0)}</div></div>
              <div className="metric-card"><div className="metric-label">Total call time</div><div className="metric-value">{Math.round(data.callStats.reduce((s,r)=>s+(r.total_seconds||0),0)/60)}m</div></div>
              <div className="metric-card"><div className="metric-label">This month</div><div className="metric-value">{data.callStats.reduce((s,r)=>s+(r.calls_this_month||0),0)}</div></div>
            </div>
            <div className="card">
              <div style={{ fontSize:'13px', fontWeight:'600', marginBottom:'14px' }}>Call time by salesperson</div>
              <ResponsiveContainer width="100%" height={220}>
                <BarChart data={data.callStats} layout="vertical">
                  <XAxis type="number" tick={{ fontSize:11 }} tickFormatter={v => `${Math.round(v/60)}m`} />
                  <YAxis type="category" dataKey="name" tick={{ fontSize:11 }} width={90} />
                  <Tooltip formatter={v => [`${Math.round(v/60)}m`, 'Call time']} />
                  <Bar dataKey="total_seconds" fill="#1D9E75" radius={[0,4,4,0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}
      </div>
    </div>
  );
 }

 // ─── Team.js ────────────────────────────────────────────────────────────────
 import { getUsers as getUsersList, createUser, updateUser } from '../api';



export function Team() {
  const { user } = useAuth();

  const [users, setUsers] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const [form, setForm] = useState({
  name: '',
  email: '',
  password: '',
  role: 'sales_manager',
  phone: '',
  team_lead_id: ''
});

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // Sirf Admin user details update kar sakta hai
  const isAdmin = user?.role === 'admin';

  const ROLE_LABELS = {
    admin: 'Admin',
    sales_head: 'Sales Head',
    team_lead: 'Team Lead',
    sales_manager: 'Sales Manager'
  };

  const load = () => {
    getUsersList()
      .then((response) => {
        setUsers(Array.isArray(response.data) ? response.data : []);
      })
      .catch((err) => {
        console.error('Could not fetch users:', err);

        setError(
          err.response?.data?.error ||
          'Could not fetch users'
        );
      });
  };

  useEffect(() => {
    load();
  }, []);

  const clearForm = () => {
  setForm({
    name: '',
    email: '',
    password: '',
    role: 'sales_manager',
    phone: '',
    team_lead_id: ''
  });

  setEditingUser(null);
  setShowAdd(false);
  setError('');
};

  const openAddForm = () => {
    setEditingUser(null);

    setForm({
  name: '',
  email: '',
  password: '',
  role: 'sales_manager',
  phone: '',
  team_lead_id: ''
});

    setError('');
    setShowAdd(true);
  };

  const openEditForm = (selectedUser) => {
    // Frontend protection: sirf Admin edit form khol sakta hai
    if (!isAdmin) {
      return;
    }

    setEditingUser(selectedUser);

    setForm({
  name: selectedUser.name || '',
  email: selectedUser.email || '',
  password: '',
  role: selectedUser.role || 'sales_manager',
  phone: selectedUser.phone || '',
  team_lead_id: selectedUser.team_lead_id
    ? String(selectedUser.team_lead_id)
    : ''
});

    setError('');
    setShowAdd(true);

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const save = async () => {
    const name = form.name.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();

    if (!name) {
      setError('Name is required');
      return;
    }

    if (!email) {
      setError('Email is required');
      return;
    }

    if (!editingUser && !form.password.trim()) {
      setError('Temporary password is required');
      return;
    }

    // Edit operation ko Admin ke alawa koi perform nahi kar sakta
    if (editingUser && !isAdmin) {
      setError('Only Admin can update users');
      return;
    }

    setSaving(true);
    setError('');

    try {
      if (editingUser) {
        const updatePayload = {
  name,
  email,
  phone,
  role: form.role,
  team_lead_id:
    form.role === 'sales_manager'
      ? (form.team_lead_id || null)
      : null
};

        // Password tabhi update hoga jab Admin naya password enter kare
        if (form.password.trim()) {
          updatePayload.password = form.password.trim();
        }

        await updateUser(editingUser.id, updatePayload);
      } else {
        await createUser({
  name,
  email,
  password: form.password,
  role: form.role,
  phone,
  team_lead_id:
    form.role === 'sales_manager'
      ? (form.team_lead_id || null)
      : null
});
      }

      clearForm();
      load();
    } catch (err) {
      console.error('User save error:', err);

      setError(
        err.response?.data?.error ||
        (
          editingUser
            ? 'Could not update user'
            : 'Could not create user'
        )
      );
    } finally {
      setSaving(false);
    }
  };

  const toggleActive = async (selectedUser) => {
    try {
      await updateUser(selectedUser.id, {
        is_active: !selectedUser.is_active
      });

      load();
    } catch (err) {
      alert(
        err.response?.data?.error ||
        'Could not update user status'
      );
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <div className="page-header">
        <div>
          <div className="page-title">
            Team & Users
          </div>

          <div className="page-subtitle">
            {users.length} team members
          </div>
        </div>

        <button
          className="btn btn-primary btn-sm"
          onClick={openAddForm}
        >
          + Add user
        </button>
      </div>

      <div className="page-body">
        {showAdd && (
          <div
            className="card"
            style={{
              maxWidth: '500px',
              marginBottom: '16px'
            }}
          >
            <div
              style={{
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '14px'
              }}
            >
              {editingUser
                ? 'Update team member'
                : 'Add team member'}
            </div>

            {error && (
              <div
                style={{
                  background: '#FCEBEB',
                  color: '#A32D2D',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  fontSize: '12px',
                  marginBottom: '10px'
                }}
              >
                {error}
              </div>
            )}

            <div className="form-row">
              <div className="form-field">
                <label className="form-label">
                  Name
                </label>

                <input
                  className="form-input"
                  value={form.name}
                  onChange={(e) =>
                    setForm((previous) => ({
                      ...previous,
                      name: e.target.value
                    }))
                  }
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  Phone
                </label>

                <input
                  className="form-input"
                  value={form.phone}
                  onChange={(e) =>
                    setForm((previous) => ({
                      ...previous,
                      phone: e.target.value
                    }))
                  }
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <label className="form-label">
                  Email
                </label>

                <input
                  className="form-input"
                  type="email"
                  value={form.email}
                  onChange={(e) =>
                    setForm((previous) => ({
                      ...previous,
                      email: e.target.value
                    }))
                  }
                />
              </div>

              <div className="form-field">
                <label className="form-label">
                  {editingUser
                    ? 'New password (optional)'
                    : 'Temporary password'}
                </label>

                <input
                  className="form-input"
                  type="password"
                  value={form.password}
                  onChange={(e) =>
                    setForm((previous) => ({
                      ...previous,
                      password: e.target.value
                    }))
                  }
                />
              </div>
            </div>

            <div className="form-field">
              <label className="form-label">
                Role
              </label>

              <select
                className="form-input"
                value={form.role}
                onChange={(e) =>
                  setForm((previous) => ({
                    ...previous,
                    role: e.target.value
                  }))
                }
              >
                <option value="sales_manager">
                  Sales Manager
                </option>

                <option value="team_lead">
                  Team Lead
                </option>

                {isAdmin && (
                  <>
                    <option value="sales_head">
                      Sales Head
                    </option>

                    <option value="admin">
                      Admin
                    </option>
                  </>
                )}
              </select>
            </div>
            {form.role === 'sales_manager' && (
  <div
    className="form-field"
    style={{ marginTop: '12px' }}
  >
    <label className="form-label">
      Assign To
    </label>

    <select
      className="form-input"
      value={form.team_lead_id || ''}
      onChange={(e) =>
        setForm((previous) => ({
          ...previous,
          team_lead_id: e.target.value
        }))
      }
    >
      <option value="">
        Select Team Lead
      </option>

      {users
        .filter(
          (teamMember) =>
            teamMember.role === 'team_lead' &&
            teamMember.is_active
        )
        .map((teamLead) => (
          <option
            key={teamLead.id}
            value={teamLead.id}
          >
            {teamLead.name}
          </option>
        ))}
    </select>
  </div>
)}

            <div
              style={{
                display: 'flex',
                gap: '8px',
                marginTop: '4px'
              }}
            >
              <button
                className="btn btn-primary btn-sm"
                onClick={save}
                disabled={saving}
              >
                {saving
                  ? 'Saving…'
                  : editingUser
                    ? 'Update user'
                    : 'Add user'}
              </button>

              <button
                className="btn btn-sm"
                onClick={clearForm}
                disabled={saving}
              >
                Cancel
              </button>
            </div>
          </div>
        )}

        <table style={{ maxWidth: '900px' }}>
          <thead>
  <tr>
    <th>Name</th>
    <th>Email</th>
    <th>Phone</th>
    <th>Role</th>
    <th>Status</th>

    {isAdmin && <th>Update</th>}
    {isAdmin && <th>Action</th>}
  </tr>
</thead>

          <tbody>
            {users.map((selectedUser) => (
              <tr key={selectedUser.id}>
                <td style={{ fontWeight: 600 }}>
                  {selectedUser.name}
                </td>

                <td
                  style={{
                    color: '#888',
                    fontSize: '12px'
                  }}
                >
                  {selectedUser.email}
                </td>

                <td style={{ fontSize: '12px' }}>
                  {selectedUser.phone || '—'}
                </td>

                <td>
                  <span className="badge badge-gray">
                    {ROLE_LABELS[selectedUser.role] ||
                      selectedUser.role}
                  </span>
                </td>

                <td>
                  <span
                    style={{
                      color: selectedUser.is_active
                        ? '#1D9E75'
                        : '#E24B4A',
                      fontSize: '12px',
                      fontWeight: 600
                    }}
                  >
                    {selectedUser.is_active
                      ? 'Active'
                      : 'Inactive'}
                  </span>
                </td>

                {isAdmin && (
                  <td>
                    <button
                      type="button"
                      title="Update user"
                      aria-label={`Update ${selectedUser.name}`}
                      onClick={() =>
                        openEditForm(selectedUser)
                      }
                      style={{
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                        fontSize: '17px',
                        padding: '4px 8px'
                      }}
                    >
                      ✏️
                    </button>
                  </td>
                )}

                {isAdmin && (
  <td>
    <button
      className="btn btn-ghost btn-sm"
      onClick={() =>
        toggleActive(selectedUser)
      }
    >
      {selectedUser.is_active
        ? 'Deactivate'
        : 'Activate'}
    </button>
  </td>
)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

 // ─── MyTasks.js ─────────────────────────────────────────────────────────────
 import { getMyTasks, completeTask as doneTaskApi } from "../api";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";

 export function MyTasks() {
  const navigate = useNavigate();

  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedDateTasks, setSelectedDateTasks] = useState(null);
const [selectedDateLabel, setSelectedDateLabel] = useState("");
  const [error, setError] = useState("");

  const loadTasks = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const response = await getMyTasks();

      setTasks(
        Array.isArray(response.data)
          ? response.data
          : []
      );
    } catch (err) {
      console.error("GET MY TASKS ERROR:", err);

      setError(
        err.response?.data?.error ||
        "Could not load tasks"
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTasks();
  }, [loadTasks]);

  const markTaskDone = async (taskId) => {
    try {
      await doneTaskApi(taskId);

      setSelectedTask(null);

      await loadTasks();
    } catch (err) {
      console.error("COMPLETE TASK ERROR:", err);

      alert(
        err.response?.data?.error ||
        "Could not complete task"
      );
    }
  };

    

const getDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const handleMoreLinkClick = (info) => {
  const dateKey = getDateKey(info.date);

  const dateTasks = tasks.filter((task) => {
    if (!task.due_date) return false;

    return String(task.due_date).slice(0, 10) === dateKey;
  });

  setSelectedDateTasks(dateTasks);

  setSelectedDateLabel(
    info.date.toLocaleDateString("en-IN", {
      month: "long",
      day: "numeric",
      year: "numeric"
    })
  );

  // FullCalendar ka default popup mat kholo
  return false;
};

const openAllLeads = () => {
  if (!selectedDateTasks || selectedDateTasks.length === 0) {
    return;
  }

  const leads = selectedDateTasks.filter(
    (task) => task.lead_id
  );

  leads.forEach((task) => {
    window.open(
      `${window.location.origin}/leads/${task.lead_id}`,
      "_blank",
      "noopener,noreferrer"
    );
  });
};

  const calendarEvents = tasks
    .filter((task) => task.due_date)
    .map((task) => {
      const date = String(task.due_date).slice(0, 10);
      const time = task.due_time
        ? String(task.due_time).slice(0, 8)
        : "00:00:00";

      return {
        id: String(task.id),

        title: task.title || "Untitled Task",

        start: `${date}T${time}`,

        allDay: !task.due_time,

        backgroundColor: "#378ADD",
        borderColor: "#378ADD",

        extendedProps: {
          task
        }
      };
    });

  const renderTaskEvent = (eventInfo) => {
    const task = eventInfo.event.extendedProps.task;

    return (
      <div
        style={{
          width: "100%",
          padding: "2px 4px",
          overflow: "hidden"
        }}
      >
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {eventInfo.timeText}
        </div>

        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {task.lead_name || "No Lead"}
        </div>

        {task.lead_phone && (
          <div
            style={{
              fontSize: 10,
              opacity: 0.9,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {task.lead_phone}
          </div>
        )}

        <div
          style={{
            fontSize: 10,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {task.title}
        </div>
      </div>
    );
  };



  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0
      }}
    >
      <div className="page-header">
        <div>
          <div className="page-title">
            My Tasks
          </div>

          <div className="page-subtitle">
            {tasks.length} pending task
            {tasks.length === 1 ? "" : "s"}
          </div>
        </div>

        <button
          className="btn btn-primary"
          type="button"
          onClick={() => {
            alert("Manual Add Task will be added in the next step.");
          }}
        >
          + Add Task
        </button>
      </div>

      {error && (
        <div
          style={{
            margin: "12px 20px 0",
            padding: "10px 14px",
            borderRadius: 8,
            background: "#FCEBEB",
            color: "#A32D2D",
            fontSize: 13
          }}
        >
          {error}
        </div>
      )}

      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          padding: 20,
          background: "#F7F7F5"
        }}
      >
        <div
          style={{
            background: "#FFFFFF",
            border: "1px solid rgba(0,0,0,0.08)",
            borderRadius: 12,
            padding: 16,
            minHeight: 700
          }}
        >
          <FullCalendar
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              listPlugin,
              interactionPlugin
            ]}
            initialView="dayGridMonth"
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth"
            }}
            
            buttonText={{
              today: "Today",
              month: "Month",
              week: "Week",
              day: "Day",
              list: "List"
            }}
                        
            events={calendarEvents}
            eventContent={renderTaskEvent}
            moreLinkClick={handleMoreLinkClick}
            eventClick={(eventInfo) => {
              setSelectedTask(
                eventInfo.event.extendedProps.task
              );
            }}


            height="auto"
            dayMaxEvents={3}
            nowIndicator={true}
            selectable={true}
            eventDisplay="block"
          />
        </div>
      </div>

{selectedDateTasks && (
  <div
    onClick={() => setSelectedDateTasks(null)}
    style={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      background: "rgba(0,0,0,0.25)",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      paddingTop: 180
    }}
  >
    <div
      onClick={(event) => event.stopPropagation()}
      style={{
        width: 360,
        maxWidth: "90vw",
        background: "#FFFFFF",
        borderRadius: 10,
        boxShadow: "0 15px 45px rgba(0,0,0,0.25)",
        overflow: "hidden"
      }}
    >

      {/* HEADER */}
      <div
        style={{
          padding: "12px 14px",
          borderBottom: "1px solid rgba(0,0,0,0.08)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10
        }}
      >
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#333",
            flex: 1
          }}
        >
          {selectedDateLabel}
        </div>

        <button
          type="button"
          onClick={openAllLeads}
          style={{
            border: "none",
            background: "#378ADD",
            color: "#FFFFFF",
            borderRadius: 6,
            padding: "6px 10px",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            whiteSpace: "nowrap"
          }}
        >
          Open All
        </button>

        <button
          type="button"
          onClick={() => setSelectedDateTasks(null)}
          style={{
            border: "none",
            background: "transparent",
            fontSize: 22,
            lineHeight: 1,
            cursor: "pointer",
            color: "#777",
            padding: "0 2px"
          }}
        >
          ×
        </button>
      </div>

      {/* TASK LIST */}
      <div
        style={{
          maxHeight: 430,
          overflowY: "auto",
          padding: 8
        }}
      >
        {selectedDateTasks.map((task) => (
          <div
            key={task.id}
            onClick={() => {
              setSelectedDateTasks(null);
              setSelectedTask(task);
            }}
            style={{
              background: "#378ADD",
              color: "#FFFFFF",
              borderRadius: 5,
              padding: "8px 10px",
              marginBottom: 5,
              cursor: "pointer"
            }}
          >
            <div
              style={{
                fontSize: 11,
                fontWeight: 700
              }}
            >
              {task.due_time
                ? String(task.due_time).slice(0, 5)
                : ""}
            </div>

            <div
              style={{
                fontSize: 12,
                fontWeight: 600
              }}
            >
              {task.lead_name || "No Lead"}
            </div>

            {task.lead_phone && (
              <div
                style={{
                  fontSize: 10,
                  opacity: 0.9
                }}
              >
                {task.lead_phone}
              </div>
            )}

            <div
              style={{
                fontSize: 10
              }}
            >
              {task.title}
            </div>
          </div>
        ))}
      </div>

    </div>
  </div>
)}

      {selectedTask && (
        <div
          onClick={() => setSelectedTask(null)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 10000,
            background: "rgba(0,0,0,0.38)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 20
          }}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              width: "100%",
              maxWidth: 460,
              background: "#FFFFFF",
              borderRadius: 14,
              boxShadow: "0 20px 60px rgba(0,0,0,0.22)",
              overflow: "hidden"
            }}
          >
            <div
              style={{
                padding: "18px 20px",
                borderBottom: "1px solid rgba(0,0,0,0.08)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: 18,
                    fontWeight: 700
                  }}
                >
                  Task Details
                </div>

                <div
                  style={{
                    marginTop: 3,
                    fontSize: 12,
                    color: "#888"
                  }}
                >
                  Pending
                </div>
              </div>

              <button
                type="button"
                onClick={() => setSelectedTask(null)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: 26,
                  cursor: "pointer",
                  color: "#777"
                }}
              >
                ×
              </button>
            </div>

            <div
              style={{
                padding: 20,
                display: "flex",
                flexDirection: "column",
                gap: 16
              }}
            >
              <TaskDetailRow
                label="Task"
                value={selectedTask.title}
              />

              <TaskDetailRow
                label="Lead"
                value={selectedTask.lead_name || "—"}
              />

              <TaskDetailRow
                label="Phone"
                value={selectedTask.lead_phone || "—"}
              />

              <TaskDetailRow
                label="Date"
                value={
                  selectedTask.due_date
                    ? new Date(
                        selectedTask.due_date
                      ).toLocaleDateString("en-IN")
                    : "—"
                }
              />

              <TaskDetailRow
                label="Time"
                value={
                  selectedTask.due_time
                    ? String(selectedTask.due_time).slice(0, 5)
                    : "—"
                }
              />
            </div>

            <div
              style={{
                padding: "16px 20px",
                borderTop: "1px solid rgba(0,0,0,0.08)",
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                flexWrap: "wrap"
              }}
            >
              <button
                type="button"
                className="btn"
                onClick={() => {
                  if (!selectedTask.lead_id) {
                    alert("This task is not linked to a lead.");
                    return;
                  }

                  navigate(`/leads/${selectedTask.lead_id}`);
                }}
              >
                Open Lead
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => markTaskDone(selectedTask.id)}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function TaskDetailRow({ label, value }) {
  return (
    <div>
      <div
        style={{
          marginBottom: 4,
          fontSize: 11,
          fontWeight: 700,
          color: "#888",
          textTransform: "uppercase",
          letterSpacing: "0.04em"
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: 14,
          color: "#222",
          wordBreak: "break-word"
        }}
      >
        {value || "—"}
      </div>
    </div>
  );
}

export default Leads;
